/* LABODÉT theme — minimal interactions (Phase 0). */

/* The desktop layout condition, shared by every module below. Mirrors the CSS
   @media queries: 1024px and wider, or 900px and wider on a screen at least
   500px tall. The second half is for wide-but-not-1024 screens that are tall
   enough for the desktop layout, e.g. iPhone Duo opened (951 × 585), which
   otherwise got the phone layout stretched across it. Phones on their side
   stay under 500px tall and keep the phone layout. */
window.LBD_DESKTOP_MQ = '(min-width: 1024px), (min-width: 900px) and (min-height: 500px)';

(function () {
  'use strict';

  // Shared body scroll-lock release. Several overlays set body.overflow =
  // 'hidden'; a module must NOT blindly clear it (that unlocks whatever ELSE
  // is open — e.g. a select-sheet closing under the open nav). Call this
  // AFTER removing your own is-open: it clears the lock only when no other
  // owner still holds it. (The monogram modal uses its own position:fixed
  // lock and is not part of this handshake.)
  function lbdReleaseLock() {
    var nav = document.getElementById('NavOverlay');
    if (nav && nav.classList.contains('is-open')) return;
    var filt = document.querySelector('[data-filter-overlay]');
    if (filt && filt.classList.contains('is-open')) return;
    document.body.style.overflow = '';
  }
  // Modules below live in their own top-level IIFEs — share via window.
  window.__lbdReleaseLock = lbdReleaseLock;

  // The PDP back link's one-shot flag must not outlive a bfcache return —
  // scripts don't re-run there, so the flag would linger and yank a LATER
  // fresh visit to the same PLP down to a stale scroll offset.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { try { sessionStorage.removeItem('lbd:backnav'); } catch (err) {} }
  });

  // ── Nav overlay ──────────────────────────────────────────
  var overlay = document.getElementById('NavOverlay');
  var navPanel = overlay && overlay.querySelector('.lbd-nav-panel');
  var navMain = overlay && overlay.querySelector('.lbd-nav-main');
  var navSubs = overlay ? Array.prototype.slice.call(overlay.querySelectorAll('.lbd-nav-sub')) : [];

  function navReset() {
    if (navPanel) navPanel.setAttribute('data-sub', '');
    if (navMain) navMain.style.transform = 'translateX(0)';
    navSubs.forEach(function (s) { s.style.transform = 'translateX(100%)'; });
  }
  function navPush(key) {
    if (!navPanel) return;
    navPanel.setAttribute('data-sub', key);
    if (navMain) navMain.style.transform = 'translateX(-100%)';
    navSubs.forEach(function (s) { s.style.transform = s.getAttribute('data-key') === key ? 'translateX(0)' : 'translateX(100%)'; });
  }
  var navOpener = null;
  function openNav() {
    if (!overlay) return;
    navOpener = document.activeElement;
    overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    // No-op when already closed — a global Escape must not clear a body lock
    // some other overlay is holding.
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true');
    lbdReleaseLock(); setTimeout(navReset, 320);
    if (navOpener && navOpener.focus) { navOpener.focus(); navOpener = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { e.preventDefault(); openNav(); }
    else if (e.target.closest('[data-nav-close]')) { e.preventDefault(); closeNav(); }
    else if (e.target.closest('[data-nav-push]')) { e.preventDefault(); navPush(e.target.closest('[data-nav-push]').getAttribute('data-nav-push')); }
    else if (e.target.closest('[data-nav-back]')) { e.preventDefault(); navReset(); }
    else if (e.target.closest('[data-foot-acc]')) {
      // Footer accordion — animate the items' height between 0 and their
      // measured scrollHeight (bulletproof across browsers; see base.css note).
      var g = e.target.closest('.lbd-foot-group');
      if (!g) return;
      var items = g.querySelector('.lbd-foot-items');
      if (!items) return;
      var isOpen = g.classList.contains('is-open');
      if (isOpen) {
        // Close: pin current height, force reflow, then animate to 0.
        items.style.height = items.scrollHeight + 'px';
        items.offsetHeight;
        items.style.height = '0px';
        g.classList.remove('is-open');
      } else {
        // Open: animate to measured scrollHeight, then release to `auto` so
        // later content/layout changes don't get capped at the measured value.
        items.style.height = items.scrollHeight + 'px';
        g.classList.add('is-open');
        items.addEventListener('transitionend', function tend(ev) {
          if (ev.propertyName !== 'height') return;
          items.removeEventListener('transitionend', tend);
          items.style.height = 'auto';
        });
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  // ── Header hide-on-scroll. TWO mechanisms, switched by viewport — mobile stays
  // ONE glide mechanism on BOTH viewports (v2 D9): a JS tween drives
  // --header-offset 0 ↔ H over 300ms with the canonical cubic-bezier sampler
  // and writes the header transform DIRECTLY each frame — every bar that reads
  // the variable (PLP filter, OOO chips, compact bars) moves in exact lockstep
  // with the header edge; no CSS transition to race the variable.
  // TRIGGERS differ: mobile is always direction-based (6px dead-zone); desktop
  // uses the sentinel position on pages that have one, else direction-based. ──
  (function () {
    var header = document.querySelector('.lbd-header');
    if (!header) return;
    var root = document.documentElement;
    var mqDesktop = window.matchMedia(window.LBD_DESKTOP_MQ);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DEAD = 6;

    // cubic-bezier(0.2, 0.7, 0.2, 1) — canonical brand easing.
    function ease(x) {
      var x1 = 0.2, y1 = 0.7, x2 = 0.2, y2 = 1;
      var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
      var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
      var fx = function (t) { return ((ax * t + bx) * t + cx) * t; };
      var dfx = function (t) { return (3 * ax * t + 2 * bx) * t + cx; };
      var t = x, i, e, d;
      for (i = 0; i < 5; i++) { e = fx(t) - x; d = dfx(t); if (Math.abs(e) < 1e-4 || d === 0) break; t -= e / d; }
      return ((ay * t + by) * t + cy) * t;
    }
    function headerH() { return header.getBoundingClientRect().height; }

    var lastY = Math.max(0, window.scrollY), dir = 0, accum = 0, ticking = false;
    // Desktop tween state (unused on mobile)
    var offset = 0, target = 0, tweenId = null;

    // — MOBILE — same direction-based trigger as always, but the GLIDE is the
    // shared JS tween (v2 D9: one mechanism on both viewports). Header
    // transform and --header-offset move together every rAF frame, so the
    // compact bars that read the variable stay in exact lockstep with the
    // header edge — no gap when it retracts, no shove when it returns.
    function updateMobile() {
      ticking = false;
      var topZone = Math.max(header.offsetTop, 8);
      var y = Math.max(0, window.scrollY), dy = y - lastY; lastY = y;
      if (y <= topZone) { dir = 0; accum = 0; glideTo(0); return; }
      if (dy === 0) return;
      var d = dy > 0 ? 1 : -1;
      if (d !== dir) { dir = d; accum = 0; }
      accum += Math.abs(dy);
      if (accum < DEAD) return;
      glideTo(d > 0 ? headerH() : 0);
    }

    // — DESKTOP — v2 tween mechanism: drive transform + offset together each rAF.
    function writeDesktop(v) {
      offset = v;
      root.style.setProperty('--header-offset', v + 'px');
      header.style.transform = 'translateY(' + (-v) + 'px)';
      // The pinned threshold (headerH − offset) shifts during the tween; resync
      // each frame so the bottom hairline doesn't lag behind the glide.
      syncPinned();
    }
    function glideTo(to) {
      if (to === target) return;
      target = to;
      if (tweenId) { cancelAnimationFrame(tweenId); tweenId = null; }
      if (reduced || to === offset) { writeDesktop(to); return; }
      var from = offset, dur = 300, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        writeDesktop(from + (to - from) * ease(p));
        tweenId = p < 1 ? requestAnimationFrame(step) : null;
      }
      tweenId = requestAnimationFrame(step);
    }
    // Desktop pinned-bar detection. A 0-height sentinel sits just above the bar
    // in flow; the threshold is the header's NATURAL bottom (headerH, NOT
    // header-aware) so the moment a user scrolls down to where the bar would
    // pin under the header, the bar takes over and the header glides away.
    // Same threshold drives both the .is-pinned hairline and the header retract.
    // Two host pages use this pattern — PLP (.lbd-filterbar) and One of One
    // (.lbd-ooo-chips) — and we only see one of them in the DOM at a time.
    function pickStickyPair() {
      var s = document.querySelector('.lbd-filterbar-sentinel');
      if (s) return { sentinel: s, bar: document.querySelector('.lbd-filterbar'), kind: 'plp' };
      s = document.querySelector('[data-ooo-sentinel]');
      if (s) return { sentinel: s, bar: document.querySelector('[data-ooo-chiprow]'), kind: 'ooo' };
      return null;
    }
    function syncPinned() {
      if (!mqDesktop.matches) return false;   // pinned styling is a desktop refinement
      var pair = pickStickyPair();
      if (!pair || !pair.sentinel || !pair.bar) return false;
      var pinned = pair.sentinel.getBoundingClientRect().top <= headerH() + 0.5;
      pair.bar.classList.toggle('is-pinned', pinned);
      return pinned;
    }
    function updateDesktop() {
      ticking = false;
      var pair = pickStickyPair();
      // Sentinel pages (PLP filter bar + One of One chips) keep their pinned
      // hairline sentinel-driven, but the header retracts DIRECTION-based (like
      // every other page) so it peeks back on any scroll up instead of staying
      // hidden for the whole list once the bar has pinned.
      if (pair && pair.sentinel) syncPinned();
      // Direction-based retract — all desktop pages.
      var topZone = Math.max(header.offsetTop, 8);
      var y = Math.max(0, window.scrollY), dy = y - lastY; lastY = y;
      if (y <= topZone) { dir = 0; accum = 0; glideTo(0); return; }
      if (dy === 0) return;
      var d = dy > 0 ? 1 : -1;
      if (d !== dir) { dir = d; accum = 0; }
      accum += Math.abs(dy);
      if (accum < DEAD) return;
      glideTo(d > 0 ? headerH() : 0);
    }

    // MOBILE is ALWAYS direction-based (v2: scroll down past the dead-zone →
    // the header glides away; any scroll up → it returns), on every page —
    // the compact filter bars handle their own appearance. The position-based
    // sentinel mechanism (bar reaches the pin line → header hands over its
    // slot) is a DESKTOP refinement only.
    function update() {
      if (mqDesktop.matches) return updateDesktop();
      return updateMobile();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    function applyMode() {
      // Reset both modes' state — the OTHER mode might have left artefacts on resize.
      if (tweenId) { cancelAnimationFrame(tweenId); tweenId = null; }
      offset = 0; target = 0; dir = 0; accum = 0;
      lastY = Math.max(0, window.scrollY);
      header.classList.remove('is-hidden');
      // ONE glide mechanism on both viewports (v2 D9): JS writes the header
      // transform + --header-offset together every rAF frame, so every bar
      // reading the variable moves in lockstep. Kill any CSS transition on
      // transform — it would race the per-frame writes.
      header.style.transform = 'translateY(0px)';
      header.style.transition = 'none';
      root.style.setProperty('--header-offset', '0px');
      if (!mqDesktop.matches) {
        // Both sentinel-paired bars — PLP filter bar and OOO chip row — drop
        // their pinned styling when the viewport leaves desktop.
        var bar = document.querySelector('.lbd-filterbar');
        if (bar) bar.classList.remove('is-pinned');
        var chips = document.querySelector('[data-ooo-chiprow]');
        if (chips) chips.classList.remove('is-pinned');
      }
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    applyMode();
    (mqDesktop.addEventListener ? mqDesktop.addEventListener.bind(mqDesktop, 'change') : mqDesktop.addListener.bind(mqDesktop))(applyMode);
  })();

  // ── PDP: variant selection (Color × Metalware) ───────────
  // Each PDP renders a <product-form> island; this wires swatch/tile
  // clicks to the hidden variant <select> + price/avail updates.
  window.LaboPDP = function (root) {
    if (!root) return;
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    // Guarded: a malformed variants JSON must degrade to a static PDP, not
    // abort every module registered after this init in the main IIFE.
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!data || !data.variants) return;
    var selected = {};
    // Mirror the selection into ?variant= so any configuration is a shareable
    // deep link (the server pre-selects it on load). Off until the shopper
    // actually picks something — a fresh PDP keeps its clean canonical URL.
    var urlSync = false;
    root.querySelectorAll('[data-opt]').forEach(function (group) {
      var name = group.getAttribute('data-opt');
      var active = group.querySelector('[data-value][aria-pressed="true"]');
      if (active) selected[name] = active.getAttribute('data-value');
    });

    // Carry-over from a Device switch: the device rows append ?color=&metal= so the
    // newly-loaded product (a sibling of the same case, different device) keeps the
    // shopper's colour + metalware instead of resetting to its default variant.
    // Pre-select the matching swatch/tile if the target offers it; if it doesn't
    // (colour sold out / absent), we silently keep the default, and refreshMetals()
    // below heals an unavailable metal for the carried colour. The params are then
    // stripped from the URL so a refresh/share is clean.
    try {
      var qp = new URLSearchParams(window.location.search);
      [['Color', 'color'], ['Metalware', 'metal']].forEach(function (pair) {
        var want = qp.get(pair[1]);
        if (!want) return;
        var group = root.querySelector('[data-opt="' + pair[0] + '"]');
        if (!group) return;
        var target = null;
        group.querySelectorAll('[data-value]').forEach(function (b) {
          if (b.getAttribute('data-value') === want) target = b;
        });
        if (!target) return;
        group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        target.setAttribute('aria-pressed', 'true');
        selected[pair[0]] = want;
        urlSync = true; // carried combo should survive a refresh, as ?variant=
      });
      if (window.history && window.history.replaceState && (qp.has('color') || qp.has('metal'))) {
        qp.delete('color'); qp.delete('metal');
        var q = qp.toString();
        window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
      }
    } catch (e) {}

    function setText(sel, val) {
      root.querySelectorAll(sel).forEach(function (el) { if (val != null) el.textContent = val; });
    }

    // ── Gallery: filter to the selected colour, jump to the selected metal ──
    // Real catalog images are keyed by "Color-Metal" in their alt (data-cm), e.g.
    // "Apple-Green-Gold". We show ONLY the selected colour's slides (hide the rest,
    // so you never scroll through every colour), and jump to the selected metal's
    // first photo. Instant scroll — no long smooth-scroll across dozens of slides.
    var gallery = root.querySelector('[data-gallery]');
    var bar = root.querySelector('[data-gallery-bar]');
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.lbd-gallery-slide')) : [];
    function colorMatch(s) {
      var cm = s.getAttribute('data-cm') || '';
      if (!selected.Color) return true;
      return cm === selected.Color || cm.indexOf(selected.Color + '-') === 0;
    }
    function metalMatch(s) {
      var cm = s.getAttribute('data-cm') || '';
      return selected.Color && selected.Metalware && cm === selected.Color + '-' + selected.Metalware;
    }
    function visibleSlides() { return slides.filter(function (s) { return s.style.display !== 'none'; }); }
    // Has filterGallery run yet? Before it has, no slide is hidden, so a
    // position read out of the visible set is meaningless — see filterGallery.
    var galleryFiltered = false;
    function updateBar() {
      var vis = visibleSlides();
      if (!gallery || !bar || !vis.length) { if (bar) bar.style.width = '0'; return; }
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      bar.style.width = ((i + 1) / vis.length * 100) + '%';
    }
    // Desktop stage + thumb rail — the thumb strip mirrors the photo filter
    // and drives which slide is the .is-main stage image.
    var thumbsWrap = root.querySelector('[data-gallery-thumbs]');
    var thumbBtns = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-thumb-index]')) : [];
    function setMain(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-main', j === i); });
      thumbBtns.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb-index'), 10) === i);
      });
    }
    function syncThumbs(prefPos) {
      if (!thumbBtns.length) return;
      var vis = [], activeVisible = false;
      slides.forEach(function (s, j) {
        var v = s.style.display !== 'none';
        if (thumbBtns[j]) thumbBtns[j].style.display = v ? '' : 'none';
        if (v) vis.push(j);
        if (v && s.classList.contains('is-main')) activeVisible = true;
      });
      // The filter hid the current view (colour/metal switch) — keep the
      // client's chosen ANGLE: the same position in the new set, so
      // comparing leathers/metals stays on the view they picked.
      if (!activeVisible && vis.length) setMain(vis[Math.min(prefPos || 0, vis.length - 1)]);
    }
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-thumb-index]');
        if (b) setMain(parseInt(b.getAttribute('data-thumb-index'), 10));
      });
    }

    function filterGallery() {
      if (!slides.length) return;
      // Which angle is the client on? Its POSITION within the visible set —
      // desktop reads the stage, mobile the scroll offset — carried across
      // the switch so the chosen view survives a colour/metal change.
      //
      // Only from the SECOND run on. On the first there is no previous view to
      // carry and nothing is hidden yet, so `prevVis` is every slide of every
      // colourway and the .is-main index read out of it is absolute, not a
      // position: Liquid puts .is-main on the selected combo's first shot, which
      // for a colour far down the media list is index 40-odd. Clamping that to
      // the handful of slides this combo actually has landed every mobile
      // pageview on the LAST photo of the set instead of the first — the deeper
      // the colour sat, the more certain it was. Desktop never showed it: there
      // the slides are display:none but .is-main, so the gallery does not
      // scroll horizontally and the stage was right all along.
      var pos = 0;
      if (galleryFiltered) {
        var prevVis = visibleSlides();
        prevVis.forEach(function (s, i) { if (s.classList.contains('is-main')) pos = i; });
        if (gallery && gallery.clientWidth && gallery.scrollLeft > 0) {
          pos = Math.round(gallery.scrollLeft / gallery.clientWidth);
        }
      }
      // Prefer exact Colour+Metal photos so switching metalware changes the images;
      // fall back to the colour's photos (then everything) when a combo has none.
      var shown = slides.filter(metalMatch);
      if (!shown.length) shown = slides.filter(colorMatch);
      if (!shown.length) shown = slides.slice();
      slides.forEach(function (s) { s.style.display = shown.indexOf(s) >= 0 ? '' : 'none'; });
      pos = Math.min(pos, shown.length - 1);
      if (gallery) gallery.scrollTo({ left: pos * gallery.clientWidth, behavior: 'auto' });
      updateBar();
      syncThumbs(pos);
      // Mobile sticky-CTA thumb follows the selection: the first shown slide
      // IS the chosen colour+metal photo (same file the gallery displays, so
      // it comes from cache). No match → the server-rendered image stays.
      var stickyImg = document.querySelector('[data-pdp-sticky] .lbd-pdp-sticky-thumb img');
      var firstImg = shown[0] && shown[0].querySelector('img');
      if (stickyImg && firstImg && firstImg.src) stickyImg.src = firstImg.src;
      galleryFiltered = true;
    }
    if (gallery) {
      gallery.addEventListener('scroll', function () { requestAnimationFrame(updateBar); }, { passive: true });
    }

    var names = window.__LABO_OPT_NAMES || [];
    var colorIdx = names.indexOf('Color');
    var metalIdx = names.indexOf('Metalware');

    // Is there a purchasable variant for this colour + metal combination?
    // (Sold-out colourways are DENY/qty0 -> available:false in data.variants.)
    function comboAvailable(color, metal) {
      return data.variants.some(function (v) {
        if (colorIdx >= 0 && v.options[colorIdx] !== color) return false;
        if (metalIdx >= 0 && v.options[metalIdx] !== metal) return false;
        return v.available;
      });
    }

    // Layer 3 - metal tiles react to the chosen colour: mute the ones with no
    // stock for that colour, and if the current metal just went dead, heal the
    // selection to the first metal that IS available (fully-dead colours are
    // hidden server-side, so an available metal always exists here).
    function refreshMetals() {
      if (metalIdx < 0) return;
      var group = root.querySelector('[data-opt="Metalware"]');
      if (!group) return;
      var tiles = Array.prototype.slice.call(group.querySelectorAll('[data-value]'));
      var currentDead = false, firstOk = null;
      tiles.forEach(function (t) {
        var mv = t.getAttribute('data-value');
        var ok = comboAvailable(selected.Color, mv);
        t.classList.toggle('is-soldout', !ok);
        t.disabled = !ok;
        if (ok && !firstOk) firstOk = t;
        if (!ok && t.getAttribute('aria-pressed') === 'true') currentDead = true;
      });
      if (currentDead && firstOk) {
        tiles.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        firstOk.setAttribute('aria-pressed', 'true');
        selected.Metalware = firstOk.getAttribute('data-value');
      }
    }

    // Layer 1 - every purchase affordance obeys availability: the mobile sticky
    // ATC and Buy it Now (which used to skip the check and leak sold-out
    // variants into checkout), alongside the main ATC handled below.
    function setBuyable(available) {
      var buyNow = document.querySelector('[data-buy-now]');
      if (buyNow) buyNow.disabled = !available;
      var sticky = document.querySelector('.lbd-pdp-sticky-add');
      if (sticky) sticky.disabled = !available;
    }

    function update() {
      // Reflect selected option names (title italic + section-head values).
      if (selected.Color) setText('[data-colour-name]', selected.Color);
      if (selected.Metalware) setText('[data-hw-name]', selected.Metalware);

      var match = data.variants.find(function (v) {
        return names.every(function (n, i) { return !selected[n] || v.options[i] === selected[n]; });
      });
      var available = match ? match.available : false;
      setBuyable(available);
      var atcEl = root.querySelector('[data-atc]');
      if (atcEl) {
        atcEl.disabled = !available;
        var albl = atcEl.querySelector('[data-atc-label]');
        if (albl) albl.textContent = available ? atcEl.getAttribute('data-label') : 'Sold out';
        if (!albl) atcEl.textContent = available ? atcEl.getAttribute('data-label') : 'Sold out';
        var atot = atcEl.querySelector('[data-atc-total]');
        if (atot && !available) atot.textContent = '';
      }
      if (!match) return;
      // European format "€ 1 700": strip EUR/€, non-breaking space thousands (matches snippets/price.liquid).
      var price = (match.price || '').replace(' EUR', '').replace('€', '').trim().replace(/,/g, ' ').replace(/\./g, ' ') + ' €';
      setText('[data-price]', price);
      // Struck old price + sale notice — only on the variant(s) that carry a
      // discount (the in-stock Outlet piece). Both toggle per-variant together.
      var onSale = !!(match.compare && match.compare !== '');
      var cmpEl = root.querySelector('[data-compare]');
      if (cmpEl) {
        if (onSale) {
          cmpEl.textContent = match.compare.replace(' EUR', '').replace('€', '').trim().replace(/,/g, ' ').replace(/\./g, ' ') + ' €';
          cmpEl.hidden = false;
        } else {
          cmpEl.textContent = '';
          cmpEl.hidden = true;
        }
      }
      var saleNote = root.querySelector('[data-sale-note]');
      if (saleNote) saleNote.hidden = !onSale;
      // Personalization isn't offered on in-stock sale items — hide the whole
      // Monogram section (and its divider) on the discounted variant.
      var monoWrap = root.querySelector('[data-monogram-wrap]');
      if (monoWrap) monoWrap.hidden = onSale;
      var idEl = root.querySelector('[name="id"]');
      if (idEl) idEl.value = match.id;
      if (urlSync && window.history && window.history.replaceState) {
        try {
          var vq = new URLSearchParams(window.location.search);
          if (vq.get('variant') !== String(match.id)) {
            vq.set('variant', match.id);
            window.history.replaceState(null, '', window.location.pathname + '?' + vq.toString() + window.location.hash);
          }
        } catch (err) {}
      }
      var atcT = root.querySelector('[data-atc] [data-atc-total]');
      if (atcT) atcT.textContent = available ? ('— ' + price) : '';
    }

    root.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.closest('[data-opt]');
        var name = group.getAttribute('data-opt');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        selected[name] = btn.getAttribute('data-value');
        urlSync = true;
        // A new colour re-scopes metal availability (may heal the metal choice).
        if (name === 'Color') refreshMetals();
        update();
        filterGallery();
      });
    });
    refreshMetals();
    update();
    filterGallery();
  };

  document.querySelectorAll('[data-product-root]').forEach(function (el) { window.LaboPDP(el); });

  // ── PDP Device switch — carry the current Colour + Metalware to the target ──
  // Each device is a separate product; its picker rows are plain links. Append the
  // shopper's current selection as ?color=&metal= so the destination PDP restores
  // the same combo (applied on load above) instead of resetting to its default.
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.lbd-device-sheet a.lbd-selrow[href]') : null;
      if (!link) return;
      var color = document.querySelector('[data-opt="Color"] [data-value][aria-pressed="true"]');
      var metal = document.querySelector('[data-opt="Metalware"] [data-value][aria-pressed="true"]');
      var params = [];
      if (color) params.push('color=' + encodeURIComponent(color.getAttribute('data-value')));
      if (metal) params.push('metal=' + encodeURIComponent(metal.getAttribute('data-value')));
      if (!params.length) return;
      var href = link.getAttribute('href');
      if (!href || /[?&](color|metal)=/.test(href)) return;
      link.setAttribute('href', href + (href.indexOf('?') >= 0 ? '&' : '?') + params.join('&'));
    });
  })();

  // ── PDP Buy it Now — add current variant then go to checkout (v2 outline btn,
  // replaces Shopify's blue dynamic-checkout button). ──
  (function () {
    var btn = document.querySelector('[data-buy-now]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var idEl = document.querySelector('[data-product-root] [name="id"]');
      var id = idEl ? idEl.value : null;
      if (!id) return;
      btn.disabled = true;
      // Carry visible line properties (e.g. Strap Size) exactly like the form post.
      var body = { id: Number(id), quantity: 1 };
      document.querySelectorAll('[data-product-root] input[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value) { body.properties = body.properties || {}; body.properties[m[1]] = inp.value; }
      });
      fetch('/cart/add.js', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          // fetch resolves on 422 too (variant sold out since page load, cart
          // limits) — never send the shopper to checkout without the item.
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () { btn.disabled = false; });
    });
  })();

  // ── PDP Strap Size (watch straps) — select-sheet rows update the hidden
  // properties[Strap Size] input + the head/trigger labels. ──
  (function () {
    var root = document.querySelector('[data-strap-size]');
    if (!root) return;
    root.addEventListener('click', function (e) {
      var row = e.target.closest('[data-strap-value]');
      if (!row) return;
      var v = row.getAttribute('data-strap-value');
      var input = root.querySelector('[data-strap-input]');
      var trig = root.querySelector('[data-strap-trigger]');
      if (input) input.value = v;
      if (trig) trig.textContent = v;
      root.querySelectorAll('[data-strap-value]').forEach(function (r) {
        var on = r === row;
        r.classList.toggle('is-current', on);
        var sel = r.querySelector('.lbd-device-selected');
        if (sel) sel.hidden = !on;
      });
    });
  })();

  // ── PDP Monogram — v2 PersonalizeModal + live bundling (/cart/add.js) ──
  // No type is selected on open (placeholder state). Picking Metal/Leather sets
  // the rule (3 letters Steel/Black, or 1 leather letter). On add, the surcharge
  // "initials" product (by letter count, or the leather product) is bundled with
  // the main product, linked by _groupHash + _initialsColor; the main line carries
  // properties.Initials + Device.
  (function () {
    var mono = document.querySelector('[data-monogram]');
    var overlay = document.querySelector('[data-mono-overlay]');
    if (!mono || !overlay) return;
    var cfg = {
      metal: { 1: mono.getAttribute('data-metal1'), 2: mono.getAttribute('data-metal2'), 3: mono.getAttribute('data-metal3') },
      leather: mono.getAttribute('data-leather'),
      device: mono.getAttribute('data-device') || '',
      cart: mono.getAttribute('data-cart') || '/cart',
      backIndex: parseInt(mono.getAttribute('data-back-index'), 10) || 0
    };
    var stageImg = overlay.querySelector('.lbd-mono-stage-img');
    // The back-view photo of the configuration the shopper built — for the modal
    // preview AND the cart line image (stored as _imageSrc), so the initials are
    // tried on the case as it will be made. Same ladder as the gallery filter:
    // the exact Colour+Metalware photos first, then the colour's. Matching on
    // the colour alone gathered every metalware of that colour, Steel shots
    // first, so a shopper who had picked Black metalware saw initials on a
    // Steel case.
    function pressedValue(opt) {
      var b = document.querySelector('[data-opt="' + opt + '"] [data-value][aria-pressed="true"]');
      return b ? b.getAttribute('data-value') : null;
    }
    function backImageSrc() {
      var color = pressedValue('Color');
      if (!color) return null;
      var metal = pressedValue('Metalware');
      var slides = Array.prototype.slice.call(document.querySelectorAll('[data-gallery] .lbd-gallery-slide'));
      var matched = [];
      if (metal) {
        matched = slides.filter(function (s) { return (s.getAttribute('data-cm') || '') === color + '-' + metal; });
      }
      if (!matched.length) {
        matched = slides.filter(function (s) {
          var cm = s.getAttribute('data-cm') || '';
          return cm === color || cm.indexOf(color + '-') === 0;
        });
      }
      if (!matched.length) return null;
      var pick = matched[Math.min(cfg.backIndex, matched.length - 1)] || matched[0];
      var img = pick.querySelector('img');
      return img ? img.src : null;
    }
    var DESC = {
      metal: 'Polished metal initials, set by hand into the case. Up to 3 characters.',
      leather: 'A single leather initial, cut and stitched by hand. One character only.'
    };
    var FINISH_COLOR = { steel: '#C8C8C8', black: '#1C1C1C' };
    var LEATHER_NAME = { white: 'White Alligator', black: 'Black Alligator' };
    var type = null, finish = 'steel', leatherColor = 'white';
    var input = overlay.querySelector('[data-mono-input]');
    var counter = overlay.querySelector('[data-mono-counter]');
    var preview = overlay.querySelector('[data-mono-preview]');
    var leatherImg = overlay.querySelector('[data-mono-leather]');
    // Read at use time: the glyph map is an inline script inside the monogram
    // snippet, so it is not guaranteed to exist when this file first runs.
    function letterUrl(color, ch) { var L = window.LABO_LETTERS || {}; return (L[color] || {})[ch] || null; }
    var errEl = overlay.querySelector('[data-mono-error]');
    var descEl = overlay.querySelector('[data-mono-typedesc]');
    var finishZone = overlay.querySelector('[data-mono-finishzone]');
    var finishLabel = overlay.querySelector('[data-mono-finish-label]');
    var leatherZone = overlay.querySelector('[data-mono-leatherzone]');
    var leatherLabel = overlay.querySelector('[data-mono-leather-label]');
    var addBtn = overlay.querySelector('[data-mono-add]');
    function maxLen() { return type === 'leather' ? 1 : 3; }
    function err(m) { if (errEl) errEl.textContent = m || ''; }
    function updateCounter() { if (counter) counter.textContent = input.value.length + '/' + maxLen(); }
    function updatePreview() {
      var t = input.value;
      // Leather: render the real letter glyph (WebP appliqué asset) in the chosen
      // colour. Metal: metallic gradient text (no asset). Missing letter →
      // graceful text fallback.
      if (type === 'leather' && t) {
        var url = letterUrl(leatherColor, t.charAt(0));
        if (leatherImg && url) {
          showGlyph(url, t);
          preview.style.display = 'none'; return;
        }
      }
      if (leatherImg) { leatherImg.hidden = true; leatherImg.removeAttribute('src'); leatherImg.classList.remove('is-in'); }
      preview.style.display = ''; preview.textContent = t;
      preview.setAttribute('data-txt', t);   // bevel layers duplicate the text via content: attr()
    }
    // Glyphs are 12–37 KB, so there is no placeholder stage: the file is fetched
    // and decoded off-screen, then swapped in with a short fade, so a letter
    // never paints half-loaded. A token drops a slow response that lands after
    // the shopper has already typed or picked something else. The same letter
    // in the other colour is warmed in the background, so flipping the swatch
    // swaps instantly.
    var glyphToken = 0;
    function showGlyph(url, t) {
      var token = ++glyphToken;
      var probe = new Image();
      probe.src = url;
      var ready = probe.decode ? probe.decode() : new Promise(function (res, rej) { probe.onload = res; probe.onerror = rej; });
      ready.then(function () {
        if (token !== glyphToken) return;
        leatherImg.src = url; leatherImg.hidden = false;
        leatherImg.classList.remove('is-in'); void leatherImg.offsetWidth; leatherImg.classList.add('is-in');
        var other = letterUrl(leatherColor === 'white' ? 'black' : 'white', t.charAt(0));
        if (other) { var warm = new Image(); warm.src = other; }
      }, function () {
        if (token !== glyphToken) return;
        leatherImg.hidden = true; preview.style.display = ''; preview.textContent = t;
      });
    }
    function setLeatherColor(c) {
      leatherColor = c; overlay.setAttribute('data-leather', c);
      leatherZone.querySelectorAll('[data-mono-leathercolor]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mono-leathercolor') === c); });
      if (leatherLabel) leatherLabel.textContent = LEATHER_NAME[c];
      updatePreview();
    }
    function updateAdd() { addBtn.disabled = !(type && input.value.length >= 1); }
    function setFinish(f) {
      finish = f; overlay.setAttribute('data-finish', f);
      finishZone.querySelectorAll('[data-mono-finish]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mono-finish') === f); });
      if (finishLabel) finishLabel.textContent = f === 'steel' ? 'Polished Steel' : 'Black';
      updatePreview();
    }
    function setType(t) {
      type = t; overlay.setAttribute('data-type', t);
      overlay.querySelectorAll('[data-mono-type]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mono-type') === t); });
      descEl.textContent = DESC[t] || '';
      input.disabled = false; input.value = ''; input.setAttribute('maxlength', String(maxLen()));
      input.setAttribute('placeholder', t === 'metal' ? 'Enter up to 3 characters' : 'Enter 1 character');
      if (t === 'metal') { finishZone.hidden = false; setFinish(finish); } else { finishZone.hidden = true; }
      if (leatherZone) { if (t === 'leather') { leatherZone.hidden = false; setLeatherColor(leatherColor); } else { leatherZone.hidden = true; } }
      err(''); updateCounter(); updatePreview(); updateAdd(); input.focus();
    }
    function reset() {
      type = null; overlay.setAttribute('data-type', ''); overlay.removeAttribute('data-finish'); finish = 'steel';
      overlay.removeAttribute('data-leather'); leatherColor = 'white';
      if (leatherZone) { leatherZone.hidden = true; setLeatherColor('white'); }
      overlay.querySelectorAll('[data-mono-type]').forEach(function (b) { b.classList.remove('is-active'); });
      descEl.textContent = ''; finishZone.hidden = true;
      input.value = ''; input.disabled = true; input.setAttribute('maxlength', '3'); input.setAttribute('placeholder', 'Select a type to begin');
      counter.textContent = '0/3'; err(''); addBtn.textContent = 'Add to Bag'; updatePreview(); updateAdd();
    }
    // iOS-proof body lock: overflow:hidden alone doesn't stop touch scrolling
    // on iOS Safari — the page under the sheet kept scrolling and could steal
    // the gesture entirely (sheet stuck mid-scroll, close button unreachable).
    // Fixing the body freezes the page for real; scroll position is saved and
    // restored on close (with scroll-behavior suppressed so it's instant).
    var lockY = 0;
    function lockBody() {
      lockY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -lockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }
    function unlockBody() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      var html = document.documentElement;
      var prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockY);
      html.style.scrollBehavior = prevBehavior;
    }
    function open() {
      overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); lockBody();
      var src = backImageSrc(); if (src && stageImg) stageImg.src = src;   // selected-colour case
      reset();
    }
    function close() { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); unlockBody(); }
    document.querySelectorAll('[data-mono-open]').forEach(function (b) { b.addEventListener('click', open); });
    overlay.querySelectorAll('[data-mono-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
    overlay.querySelectorAll('[data-mono-type]').forEach(function (b) { b.addEventListener('click', function () { setType(b.getAttribute('data-mono-type')); }); });
    finishZone.querySelectorAll('[data-mono-finish]').forEach(function (b) { b.addEventListener('click', function () { setFinish(b.getAttribute('data-mono-finish')); }); });
    if (leatherZone) leatherZone.querySelectorAll('[data-mono-leathercolor]').forEach(function (b) { b.addEventListener('click', function () { setLeatherColor(b.getAttribute('data-mono-leathercolor')); }); });
    input.addEventListener('input', function () {
      // Strip anything outside A–Z / 0–9 (diacritics, cyrillic, symbols…) and
      // say so under the field instead of failing silently.
      var raw = input.value.toUpperCase();
      var clean = raw.replace(/[^A-Z0-9]/g, '');
      var hadInvalid = clean.length !== raw.length;
      input.value = clean.slice(0, maxLen());
      updateCounter(); updatePreview(); updateAdd();
      err(hadInvalid ? 'Latin letters and numerals only.' : '');
    });
    // iOS pans the window to lift the focused field above the keyboard and can
    // LEAVE that pan behind after Done — the body is position:fixed, so the
    // page can't have scrolled itself, yet every later tap lands offset (the
    // input becomes untappable, taps on the type buttons hit the input…).
    // Snap the window back once the keyboard is gone.
    input.addEventListener('blur', function () {
      if (!overlay.classList.contains('is-open')) return;
      setTimeout(function () {
        var html = document.documentElement;
        var prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, 0);
        html.style.scrollBehavior = prev;
      }, 60);
    });
    // The disabled input swallows taps, and its placeholder ("Select a type to
    // begin") reads as generic filler — so a tap on the field BEFORE a type is
    // chosen now answers: a caption under the field + a glide up to the type
    // buttons. Listener sits on the wrapper (disabled inputs fire no events).
    var inputWrap = overlay.querySelector('.lbd-mono-inputwrap');
    if (inputWrap) inputWrap.addEventListener('click', function () {
      if (type) return;
      err('Select Metal or Leather first.');
      var types = overlay.querySelector('.lbd-mono-types');
      if (types) types.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    addBtn.addEventListener('click', function () {
      if (!type) return;
      var text = (input.value || '').trim();
      if (!text) { err('Please enter at least one character.'); return; }
      var mainEl = document.querySelector('[data-product-root] [name="id"]');
      var mainId = mainEl ? mainEl.value : null;
      if (!mainId) { err('Please select your options.'); return; }
      // _initialsColor is what the workshop reads on the order. White leather
      // keeps its historical value 'Off-White' so nothing downstream changes;
      // black leather is 'Black' — told apart from black metal by the bundled
      // surcharge product (leather vs metal) and _initialsType on the case line.
      var color = type === 'metal' ? (finish === 'steel' ? 'Steel' : 'Black') : (leatherColor === 'black' ? 'Black' : 'Off-White');
      var initialsId = type === 'metal' ? cfg.metal[text.length] : cfg.leather;
      if (!initialsId) { err('Personalization unavailable.'); return; }
      var groupHash = String(Date.now());
      var backSrc = backImageSrc() || '';
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(initialsId), quantity: 1, properties: { _groupHash: groupHash, _initialsColor: color } },
          { id: Number(mainId), quantity: 1, properties: { Initials: text, Device: cfg.device, _groupHash: groupHash, _initialsColor: color, _imageSrc: backSrc, _initialsType: type } }
        ] })
      }).then(function (r) {
        // Shopify returns parseable JSON on 422 as well — a failed bundle add
        // (initials product unpublished / OOS) must not navigate to the cart.
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () { window.location.href = cfg.cart; })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add to Bag'; err('Something went wrong. Please try again.'); });
    });
    // bfcache return from the cart restores the page mid-"Adding…" with the
    // dialog open and the body position:fixed — put everything back.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      addBtn.disabled = false; addBtn.textContent = 'Add to Bag'; updateAdd();
      if (overlay.classList.contains('is-open')) close();
    });
  })();

  // ── PDP mobile sticky CTA — slide in once the main CTA scrolls under the header ──
  (function () {
    var sticky = document.querySelector('[data-pdp-sticky]');
    var cta = document.querySelector('[data-pdp-cta]');
    if (!sticky || !cta) return;
    var header = document.querySelector('.lbd-header');
    var ticking = false;
    function update() {
      ticking = false;
      if (window.matchMedia(window.LBD_DESKTOP_MQ).matches) { sticky.classList.remove('is-shown'); sticky.setAttribute('aria-hidden', 'true'); return; }
      var hb = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var show = cta.getBoundingClientRect().bottom < hb && window.scrollY > 300;
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  })();

  // ── Colour-matched cross-sell — PDP "This leather, other objects." AND the
  // cart's "You may also like." (same engine, two roots) ──
  // Pulls same-leather accessories via the Section Rendering API (read-only
  // storefront search), ranks by colour match, keeps one card per category
  // (max 4). PDP mode ([data-color-match]): hidden until cards arrive, follows
  // the live colour swatch, drops the current product. Cart mode
  // ([data-cart-also]): renders over a server-side fallback (kept on failure,
  // never hidden), colour is fixed by the bag's lead line, and everything
  // already in the bag is excluded — by product handle AND by category
  // (data-exclude-handles / data-exclude-fams, comma lists from Liquid).
  (function () {
    function wire(root) {
      var grid = root.querySelector('[data-cm-grid]');
      var sectionId = root.getAttribute('data-section');
      var skin = root.getAttribute('data-skin') || '';
      if (!grid || !sectionId) return;
      var cartMode = root.hasAttribute('data-cart-also');
      var currentHandle = root.getAttribute('data-handle');
      var exHandles = ',' + (root.getAttribute('data-exclude-handles') || '') + ',';
      var exFams = ',' + (root.getAttribute('data-exclude-fams') || '') + ',';

      function shuffle(a) {
        for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
        return a;
      }
      // Raw Color option value of the selected swatch (multi-colour products switch live).
      function currentColorRaw() {
        if (!cartMode) {
          var pressed = document.querySelector('[data-opt="Color"] [data-value][aria-pressed="true"]');
          if (pressed) return pressed.getAttribute('data-value');
        }
        return root.getAttribute('data-color-raw') || '';
      }
      function fail() { if (!cartMode) root.hidden = true; } // cart keeps its fallback

      var lastQuery = null;
      function load() {
        var raw = currentColorRaw();
        if (!raw && !skin) { fail(); return; }
        if (raw === lastQuery) return;             // already loaded for this colour
        lastQuery = raw;
        // Pass colour + leather to the section via the search query (q=colour~leather).
        var q = raw + '~' + skin;
        var url = '/search?q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(sectionId);
        fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function (html) {
            if (raw !== lastQuery) return;   // stale response — a newer colour won
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = Array.prototype.slice.call(doc.querySelectorAll('.lbd-cm-card'));
            // Section is leather-first and tags each card by colour match
            // (data-cmatch: 2 exact colour, 1 same colour-group, 0 leather only).
            // Rank best-match first, random within a tier for variety.
            function cmatchOf(c) { return parseInt(c.getAttribute('data-cmatch'), 10) || 0; }
            function byMatch(arr) {
              return shuffle(arr.slice()).sort(function (a, b) { return cmatchOf(b) - cmatchOf(a); });
            }
            var byFam = {};
            cards.forEach(function (c) {
              var h = c.getAttribute('data-handle');
              if (h === currentHandle) return;                    // not this product (PDP)
              if (exHandles.indexOf(',' + h + ',') >= 0) return;  // not what's in the bag
              var fam = c.getAttribute('data-family') || c.getAttribute('data-type') || '';
              if (exFams.indexOf(',' + fam + ',') >= 0) return;   // bag already covers this category
              (byFam[fam] = byFam[fam] || []).push(c);
            });
            var fams = Object.keys(byFam);
            // One best card per category (variety), then everything else as fillers.
            var perFam = [], rest = [];
            fams.forEach(function (f) {
              var arr = byMatch(byFam[f]);
              perFam.push(arr[0]);
              for (var i = 1; i < arr.length; i++) rest.push(arr[i]);
            });
            // Colour-matched categories lead; fill remaining slots with the best
            // leftovers so the row always reaches 4 when the leather has the pieces.
            var out = byMatch(perFam).concat(byMatch(rest)).slice(0, 4);
            if (!out.length) { fail(); return; }
            grid.innerHTML = '';
            out.forEach(function (c) { grid.appendChild(c); });
            root.hidden = false;
          })
          .catch(function () {
            lastQuery = null;   // transient failure — allow a retry for this colour
            fail();
          });
      }

      load();
      if (!cartMode) {
        // Re-run when the colour changes on a multi-colour product.
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-opt="Color"] [data-value]')) { setTimeout(load, 80); }
        });
      }
    }
    document.querySelectorAll('[data-color-match], [data-cart-also]').forEach(wire);
  })();

  // ── PLP filter drawer — open/close, scroll-lock, live counts, clear all ──
  // Selection visuals are pure-CSS (:checked); JS drives the overlay + the
  // per-section "N selected" counts. Apply is a normal form submit (Shopify
  // native filtering). Clear All resets the drawer (v2: Apply then applies).
  (function () {
    var overlay = document.querySelector('[data-filter-overlay]');
    if (!overlay) return;

    var filterOpener = null;
    function openFilter() {
      filterOpener = document.activeElement;
      overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeFilter() {
      overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); lbdReleaseLock();
      if (filterOpener && filterOpener.focus) { filterOpener.focus(); filterOpener = null; }
    }

    // Any trigger opens it (the bar Filter button AND the mobile compact bar).
    document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.addEventListener('click', openFilter); });
    overlay.querySelectorAll('[data-filter-close]').forEach(function (b) { b.addEventListener('click', closeFilter); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeFilter(); });

    function updateCounts() {
      var anySelected = false;
      overlay.querySelectorAll('[data-fsection]').forEach(function (sec) {
        // Colour is grouped: count active groups, not the many member checkboxes.
        var groups = sec.querySelectorAll('[data-cg-group]');
        var n = groups.length
          ? sec.querySelectorAll('[data-cg-group].is-active').length
          : sec.querySelectorAll('input[type="checkbox"]:checked').length;
        if (n > 0) anySelected = true;
        var c = sec.querySelector('[data-fcount]');
        if (c) { c.textContent = n + ' selected'; c.classList.toggle('is-empty', n === 0); }
      });
      // Price counts as a selection too — guard the .is-filtered class.
      var priceFilled = false;
      overlay.querySelectorAll('.lbd-fprice-field input').forEach(function (i) {
        if (i.value && i.value.trim() !== '') priceFilled = true;
      });
      // Stay "filtered" when the URL already has applied filters — unticking them
      // in the drawer still needs Apply (to submit the empty state = reset).
      var hasApplied = overlay.hasAttribute('data-applied');
      var isFiltered = anySelected || priceFilled || hasApplied;
      overlay.classList.toggle('is-filtered', isFiltered);
      // Footer stays put; Apply just enables/disables (Clear All hides via CSS).
      var apply = overlay.querySelector('.lbd-filter-apply');
      if (apply) apply.disabled = !isFiltered;
    }
    overlay.addEventListener('change', function (e) { if (e.target.matches('input')) updateCounts(); });
    overlay.addEventListener('input', function (e) { if (e.target.matches('.lbd-fprice-field input')) updateCounts(); });

    // Colour groups: one swatch toggles all its member colour checkboxes together.
    overlay.addEventListener('click', function (e) {
      var g = e.target.closest('[data-cg-group]');
      if (!g) return;
      var members = g.querySelectorAll('input[data-cg-member]');
      if (!members.length) return;
      var active = !g.classList.contains('is-active');
      g.classList.toggle('is-active', active);
      var sw = g.querySelector('.lbd-swatch');
      if (sw) { if (active) { sw.setAttribute('aria-pressed', 'true'); } else { sw.removeAttribute('aria-pressed'); } }
      for (var i = 0; i < members.length; i++) members[i].checked = active;
      updateCounts();
    });

    // Clear All is a link to the bare collection URL (see filter-drawer.liquid
    // footer) — Shopify-native reset, no in-place "uncheck and stay" mode.
    updateCounts();
  })();

  // ── PLP Device / Sort select-sheets — open/close (bottom-sheet mobile, dropdown desktop) ──
  // Selection itself needs no JS: device rows are <a> links, sort rows are submit
  // buttons in the filter form. This only toggles visibility + scroll-lock (mobile).
  (function () {
    var sheets = Array.prototype.slice.call(document.querySelectorAll('[data-sheet]'));
    if (!sheets.length) return;

    function closeAll() {
      // Only touch the body lock when a sheet was actually open — this runs on
      // EVERY document click, and blindly clearing overflow was unlocking the
      // page behind the nav / filter drawer on any stray tap.
      var wasOpen = false;
      sheets.forEach(function (s) {
        if (s.classList.contains('is-open')) wasOpen = true;
        s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true');
      });
      if (wasOpen) lbdReleaseLock();
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sheet-open]');
      if (trigger) {
        e.preventDefault(); e.stopPropagation();
        // Compact-bar triggers target a sheet by id; in-bar controls find their
        // adjacent sheet in the same wrapper.
        var targetId = trigger.getAttribute('data-sheet-target');
        var sheet = targetId ? document.getElementById(targetId) : trigger.parentNode.querySelector('[data-sheet]');
        var wasOpen = sheet && sheet.classList.contains('is-open');
        closeAll();
        if (sheet && !wasOpen) {
          sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
          if (!window.matchMedia(window.LBD_DESKTOP_MQ).matches) document.body.style.overflow = 'hidden';
        }
        return;
      }
      if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); closeAll(); return; }
      // Outside click (desktop dropdown) — close if click is outside any open panel.
      if (!e.target.closest('.lbd-selsheet-panel') && !e.target.closest('[data-sheet-open]')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();

  // ── PLP mobile compact bar — show once the main control bar scrolls under the
  // header (v2 StickyCompactBar). Desktop pins the full bar instead, so no-op there. ──
  (function () {
    var compact = document.querySelector('[data-compact-bar]');
    var mainBar = document.querySelector('.lbd-filterbar');
    if (!compact || !mainBar) return;
    var header = document.querySelector('.lbd-header');
    var ticking = false;
    function update() {
      ticking = false;
      if (window.matchMedia(window.LBD_DESKTOP_MQ).matches) { compact.classList.remove('is-shown'); return; }
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var show = mainBar.getBoundingClientRect().bottom <= headerBottom;
      compact.classList.toggle('is-shown', show);
      compact.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  })();

  // ── Carousel hover arrows (desktop) — v2 CarouselArrows ──
  // Arrows page between EXPLICIT card snap positions with a smooth glide:
  // programmatic scrollBy is not obliged to honor CSS snap points (drag/wheel
  // are), which is why arrow clicks used to land with a card sliced at the
  // edge. The rail ends at the last card's right edge on BOTH viewports —
  // no travel-home spacer (a lone last card beside a void reads wrong).
  document.querySelectorAll('.lbd-carousel').forEach(function (c) {
    var row = c.querySelector('[data-crow]');
    if (!row) return;
    // Arrows live in the section's heading row (outside .lbd-carousel), so
    // resolve them through the shared section scope.
    var scope = c.closest('.lbd-carousel-section') || c;
    var prev = scope.querySelector('[data-crow-prev]');
    var next = scope.querySelector('[data-crow-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function cards() {
      return Array.prototype.slice.call(row.children);
    }
    function snapPad() {
      var v = parseFloat(getComputedStyle(row).scrollPaddingLeft);
      return isNaN(v) ? 0 : v;
    }
    function metrics() {
      var list = cards();
      if (!list.length) return null;
      var stepW = list[1] ? (list[1].offsetLeft - list[0].offsetLeft) : list[0].offsetWidth;
      var gap = Math.max(0, stepW - list[0].offsetWidth);
      return { list: list, stepW: stepW, gap: gap };
    }
    function upd() {
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    }
    // Page by whole cards to an explicit aligned position, smooth glide.
    function step(d) {
      var m = metrics();
      if (!m) return;
      var pad = snapPad();
      var perPage = Math.max(1, Math.round((row.clientWidth + m.gap) / m.stepW));
      var cur = Math.round((row.scrollLeft - (m.list[0].offsetLeft - pad)) / m.stepW);
      var target = Math.max(0, Math.min(m.list.length - 1, cur + d * perPage));
      row.scrollTo({ left: m.list[target].offsetLeft - pad, behavior: reduced ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', function () {
      requestAnimationFrame(upd);
    }, { passive: true });
    upd();
  });

  // ── One of One — chip filter + N° re-numbering + lazy page-merge + sticky compact bar ──
  // Pieces are rendered by sections/page-oneofone.liquid as a flat list with
  // data-model-type per piece. On init we fetch every remaining paginate page
  // via the Section Rendering API and append the pieces into the same .lbd-ooo-frame,
  // so the chip filter sees the WHOLE collection (~423), not just the current page.
  // Clicking a chip flips data-active on the wrap (CSS hides non-matching pieces
  // via .is-active), and we re-number the visible subset so N°01 / N°02… stays
  // meaningful within the filter. The mobile compact bar shows once the chip row
  // scrolls off; tapping it opens the existing #OneOfOneFilterSheet (driven by
  // the same data-ooo-chip handler, so picking a row applies the filter and
  // closes the sheet via [data-sheet-close]).
  document.querySelectorAll('[data-ooo-wrap]').forEach(function (wrap) {
    var frame = wrap.querySelector('[data-ooo-frame]');
    var chiprow = wrap.querySelector('[data-ooo-chiprow]');
    var counter = wrap.querySelector('[data-ooo-count]');
    var compact = wrap.querySelector('[data-ooo-compactbar]');
    var compactLabel = wrap.querySelector('[data-ooo-compact-label]');
    var sheetBody = wrap.querySelector('[data-ooo-sheet-body]');
    var pager = wrap.querySelector('[data-ooo-pager]');
    if (!frame) return;

    function pieces() { return wrap.querySelectorAll('[data-ooo-piece]'); }
    function chips() { return wrap.querySelectorAll('[data-ooo-chip]'); }

    function setCompactLabel(value) {
      if (!compactLabel) return;
      compactLabel.textContent = value === 'all' ? 'All pieces' : value;
    }

    function applyFilter(value) {
      wrap.setAttribute('data-active', value);
      chips().forEach(function (c) {
        var match = c.getAttribute('data-ooo-chip') === value;
        c.setAttribute('aria-selected', match ? 'true' : 'false');
        // Sheet rows reuse the .lbd-selrow.is-current treatment from PLP.
        if (c.classList.contains('lbd-selrow')) c.classList.toggle('is-current', match);
      });
      var visibleIdx = 0, firstVisible = null;
      pieces().forEach(function (p) {
        var mt = p.getAttribute('data-model-type') || '';
        var match = value === 'all' || mt === value;
        p.classList.toggle('is-active', match);
        p.classList.remove('is-first-visible');
        if (match) {
          visibleIdx++;
          if (!firstVisible) firstVisible = p;
          var n = p.querySelector('[data-ooo-num]');
          if (n) n.textContent = visibleIdx < 10 ? '0' + visibleIdx : String(visibleIdx);
        }
      });
      if (firstVisible) firstVisible.classList.add('is-first-visible');
      if (counter) counter.textContent = String(visibleIdx);
      setCompactLabel(value);
    }

    // Chip click — delegated so newly-added sheet rows + dynamically-added
    // chips (post-merge) all work. If the tapped chip lives inside the bottom
    // sheet, close the sheet right after applying so a mobile pick feels like
    // "open · pick · gone".
    wrap.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ooo-chip]');
      if (!c || !wrap.contains(c)) return;
      applyFilter(c.getAttribute('data-ooo-chip'));
      var sheet = c.closest('.lbd-selsheet');
      if (sheet) {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        lbdReleaseLock();
      }
    });

    // ── Lazy-fetch every remaining paginate page via Section Rendering API.
    // After every page is merged into .lbd-ooo-frame the pager is removed and
    // any new model types are appended to the chip row + sheet (so the filter
    // covers the FULL collection, not just the current page).
    function mergeRemainingPages() {
      var sectionId = wrap.getAttribute('data-ooo-section-id');
      var pagePath = wrap.getAttribute('data-ooo-page-url') || window.location.pathname;
      var pages = parseInt(frame.getAttribute('data-ooo-pages'), 10) || 1;
      var current = parseInt(frame.getAttribute('data-ooo-current-page'), 10) || 1;
      if (!sectionId || pages <= 1) return;

      var queue = [];
      for (var p = 1; p <= pages; p++) if (p !== current) queue.push(p);

      var seenTypes = {};
      chips().forEach(function (c) { seenTypes[c.getAttribute('data-ooo-chip')] = true; });

      Promise.all(queue.map(function (p) {
        return fetch(pagePath + '?sections=' + encodeURIComponent(sectionId) + '&page=' + p, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { return (data && data[sectionId]) ? data[sectionId] : null; })
          .catch(function () { return null; });
      })).then(function (htmls) {
        var tmp = document.createElement('div');
        htmls.forEach(function (html) {
          if (!html) return;
          tmp.innerHTML = html;
          // Append every piece from the fetched section into our current frame.
          tmp.querySelectorAll('[data-ooo-piece]').forEach(function (p) { frame.appendChild(p); });
        });
        // Discover any model types that only exist on later pages and append
        // them to the desktop chip row + the mobile filter sheet.
        var newChips = [];
        wrap.querySelectorAll('[data-ooo-piece]').forEach(function (p) {
          var mt = p.getAttribute('data-model-type') || '';
          if (mt && !seenTypes[mt]) { seenTypes[mt] = true; newChips.push(mt); }
        });
        if (newChips.length) {
          newChips.forEach(function (mt) {
            if (chiprow) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'lbd-ooo-chip'; b.setAttribute('role', 'tab');
              b.setAttribute('aria-selected', 'false'); b.setAttribute('data-ooo-chip', mt);
              b.textContent = mt;
              var inner = chiprow.querySelector('.lbd-ooo-chips-inner') || chiprow;
              inner.appendChild(b);
            }
            if (sheetBody) {
              var row = document.createElement('button');
              row.type = 'button'; row.className = 'lbd-selrow'; row.setAttribute('data-ooo-chip', mt);
              row.innerHTML = '<span class="lbd-selrow-name serif">' + mt.replace(/[&<>"']/g, function (ch) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[ch];
              }) + '</span><svg class="lbd-selrow-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 12l5 5L19 7"/></svg>';
              // Insert before the trailing spacer div if present.
              var trail = sheetBody.querySelector(':scope > div:last-child');
              if (trail) sheetBody.insertBefore(row, trail); else sheetBody.appendChild(row);
            }
          });
        }
        // Pager retired — every page is now in the DOM.
        if (pager) pager.remove();
        // Re-apply the current filter so accumulated pieces inherit visibility
        // + the N°XX numbering covers the full set.
        applyFilter(wrap.getAttribute('data-active') || 'all');
      });
    }

    // ── Mobile compact bar — show once the chip row has scrolled past the
    // header's bottom edge, hide when it's back on screen. Desktop ignores
    // this (CSS @media kills .lbd-ooo-compactbar at the desktop breakpoint).
    function getHeaderH() {
      var h = document.querySelector('.lbd-header');
      return h ? h.getBoundingClientRect().height : 56;
    }
    var compactTicking = false;
    function compactUpdate() {
      compactTicking = false;
      if (!compact || !chiprow) return;
      var rect = chiprow.getBoundingClientRect();
      var shown = rect.bottom <= getHeaderH() + 1;
      compact.classList.toggle('is-shown', shown);
      compact.setAttribute('aria-hidden', shown ? 'false' : 'true');
    }
    function onCompactScroll() {
      if (!compactTicking) { compactTicking = true; requestAnimationFrame(compactUpdate); }
    }
    if (compact && chiprow) {
      window.addEventListener('scroll', onCompactScroll, { passive: true });
      window.addEventListener('resize', onCompactScroll, { passive: true });
      compactUpdate();
    }

    // Initial filter (also marks .is-first-visible).
    applyFilter('all');
    mergeRemainingPages();
  });

  // ── Announcement strip rotator ─────────────────────────────────────────
  // For each [data-announce-rotator] with ≥ 2 [data-announce-slide] children,
  // rotates them on a fixed delay. CSS owns the motion (.is-active / .is-leaving
  // → translateY + opacity over 700ms, canonical cubic-bezier). We toggle the
  // classes in lockstep so the leaving and incoming slides cross-pass mid-bar:
  // the current slide slides UP & fades, the next slide rises FROM BELOW & fades
  // in — symmetric, no flicker. Single-slide rotators are static. Tabs hidden →
  // pause (page-visibility) so the message you come back to is the same one you
  // left. Reduced motion → straight opacity in CSS, JS timing unchanged.
  document.querySelectorAll('[data-announce-rotator]').forEach(function (rot) {
    var slides = Array.prototype.slice.call(rot.querySelectorAll('[data-announce-slide]'));
    if (slides.length <= 1) return;
    var delay = Math.max(2000, parseInt(rot.getAttribute('data-delay'), 10) || 6000);
    var idx = 0, timerId = null, paused = false;

    function step() {
      var current = slides[idx];
      idx = (idx + 1) % slides.length;
      var next = slides[idx];
      // Prep next: ensure it's NOT already leaving (would carry a -100% transform),
      // then in the NEXT frame add is-active so the CSS transition fires from the
      // resting "below the bar" state. Two rAFs guarantee the browser commits the
      // intermediate style — single rAF can collapse adjacent class changes.
      next.classList.remove('is-leaving');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          current.classList.remove('is-active');
          current.classList.add('is-leaving');
          current.setAttribute('aria-hidden', 'true');
          next.classList.add('is-active');
          next.setAttribute('aria-hidden', 'false');
        });
      });
      // Drop the leaving class after the transition so the same slide can come
      // back into rotation cleanly on the next pass.
      setTimeout(function () { current.classList.remove('is-leaving'); }, 800);
    }

    function start() { if (!timerId && !paused) timerId = setInterval(step, delay); }
    function stop() { if (timerId) { clearInterval(timerId); timerId = null; } }

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
      if (paused) stop(); else start();
    });

    start();
  });

})();

/* ════════════════════════════════════════════════════════════
   Contact form — isolated IIFE (kept OUTSIDE the main block so an
   unrelated error elsewhere in theme.js can never disable it).
   - Topic / country-code SELECT (sheet on mobile, dropdown on desktop)
   - Order-number reveal when Topic = "Order or shipping"
   - Validation mirroring v2 lib/validators.js: errors surface on blur
     (touched) and on submit (all touched), with the exact v2 strings.
   - Send button dims (.is-incomplete) until the form is valid, but stays
     hoverable + clickable so a tap reveals the outstanding errors (v2).
   Real submission is Shopify's {% form 'contact' %}.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-contact-form]');
  if (!root) return;
  var formEl = root.closest('form');
  if (!formEl) return;

  function field(name) { return root.querySelector('[data-field-name="' + name + '"]'); }
  function showErr(name, msg) {
    var f = field(name); if (!f) return;
    f.classList.add('is-error');
    var e = f.querySelector('[data-err]');
    if (e) { e.textContent = msg; e.removeAttribute('hidden'); }
  }
  function hideErr(name) {
    var f = field(name); if (!f) return;
    f.classList.remove('is-error');
    var e = f.querySelector('[data-err]');
    if (e) e.setAttribute('hidden', '');
  }

  // ── Validators — ported 1:1 from v2 lib/validators.js (null = valid) ──
  function vName(v) { v = (v || '').trim(); if (!v) return 'REQUIRED'; if (v.length < 2) return 'ENTER YOUR FULL NAME'; if (!/^[\p{L}\s'-]+$/u.test(v)) return 'LETTERS ONLY'; return null; }
  function vEmail(v) { v = (v || '').trim(); if (!v) return 'REQUIRED'; if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'ENTER A VALID EMAIL ADDRESS'; return null; }
  function vPhone(v) { v = (v || '').replace(/[\s\-()]/g, ''); if (!v) return null; if (!/^\d+$/.test(v)) return 'ENTER A VALID PHONE NUMBER'; if (v.length < 7) return 'ENTER A VALID PHONE NUMBER'; return null; }
  function vMessage(v) { v = (v || '').trim(); if (!v) return 'REQUIRED'; if (v.length < 10) return 'MESSAGE IS TOO SHORT'; return null; }
  function vTopic(v) { if (!v || !v.trim()) return 'SELECT A TOPIC'; return null; }
  function vTerms(c) { return c ? null : 'MUST ACCEPT TERMS TO CONTINUE'; }

  var topicLabel = root.querySelector('[data-topic-label]');
  var topicInput = root.querySelector('[data-topic-input]');
  var ccLabel = root.querySelector('[data-cc-label]');
  var ccInput = root.querySelector('[data-cc-input]');
  var reveal = root.querySelector('[data-order-reveal]');
  var termsInput = root.querySelector('[data-terms]');
  var submitBtn = root.querySelector('[data-contact-submit]');

  var VALIDATORS = { topic: vTopic, name: vName, email: vEmail, phone: vPhone, message: vMessage, terms: vTerms };
  var FIELDS = ['topic', 'name', 'email', 'phone', 'message', 'terms'];
  var touched = {};

  function getVal(name) {
    if (name === 'topic') return topicInput ? topicInput.value : '';
    if (name === 'terms') return termsInput ? termsInput.checked : false;
    var f = field(name); var el = f && f.querySelector('input, textarea');
    return el ? el.value : '';
  }
  function errorFor(name) { var fn = VALIDATORS[name]; return fn ? fn(getVal(name)) : null; }
  function formValid() { for (var i = 0; i < FIELDS.length; i++) { if (errorFor(FIELDS[i])) return false; } return true; }
  function refreshButton() { if (submitBtn) submitBtn.classList.toggle('is-incomplete', !formValid()); }
  function reflect(name) { var msg = errorFor(name); if (msg && touched[name]) showErr(name, msg); else hideErr(name); }

  function markCurrent(btn) {
    var body = btn.closest('.lbd-selsheet-body'); if (!body) return;
    body.querySelectorAll('.lbd-selrow').forEach(function (r) { r.classList.remove('is-current'); });
    btn.classList.add('is-current');
  }
  function closeSheet(el) {
    var s = el.closest('.lbd-selsheet'); if (!s) return;
    s.classList.remove('is-open');
    s.setAttribute('aria-hidden', 'true');
    window.__lbdReleaseLock();
    var trig = s.parentNode.querySelector('[data-sheet-open]');
    if (trig) trig.setAttribute('aria-expanded', 'false');
  }
  function updateReveal(value) {
    if (!reveal) return;
    var on = value === 'Order or shipping';
    reveal.classList.toggle('is-shown', on);
    reveal.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (!on) { var oi = reveal.querySelector('input'); if (oi) oi.value = ''; }
  }

  // ── Topic / country-code selection (works for sheet rows + dropdown rows) ──
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-contact-topic]');
    if (t && root.contains(t)) {
      var val = t.getAttribute('data-contact-topic');
      if (topicInput) topicInput.value = val;
      if (topicLabel) { topicLabel.textContent = val; topicLabel.classList.remove('is-placeholder'); }
      markCurrent(t); touched.topic = true; reflect('topic'); updateReveal(val); refreshButton(); closeSheet(t);
      return;
    }
    var c = e.target.closest('[data-contact-cc]');
    if (c && root.contains(c)) {
      var code = c.getAttribute('data-contact-cc');
      if (ccInput) ccInput.value = code;
      if (ccLabel) ccLabel.textContent = code;
      markCurrent(c); closeSheet(c);
      return;
    }
  });

  // Keep the ink ring (aria-expanded) on our select triggers in sync after the
  // generic [data-sheet] handler toggles a sheet open/closed.
  document.addEventListener('click', function () {
    root.querySelectorAll('[data-sheet-open]').forEach(function (trig) {
      var sheet = trig.parentNode.querySelector('[data-sheet]');
      trig.setAttribute('aria-expanded', sheet && sheet.classList.contains('is-open') ? 'true' : 'false');
    });
  });

  // ── Live validation — blur marks touched + shows the error; typing updates it
  //    live; the Send button always reflects current validity. ──
  ['name', 'email', 'phone', 'message'].forEach(function (name) {
    var f = field(name); var el = f && f.querySelector('input, textarea'); if (!el) return;
    el.addEventListener('blur', function () { touched[name] = true; reflect(name); refreshButton(); });
    el.addEventListener('input', function () { reflect(name); refreshButton(); });
  });
  if (termsInput) termsInput.addEventListener('change', function () { touched.terms = true; reflect('terms'); refreshButton(); });

  // Textarea auto-grow (v2 UnderlineTextarea).
  var ta = root.querySelector('[data-autogrow]');
  if (ta) {
    var grow = function () {
      ta.style.height = 'auto';
      var h = Math.min(Math.max(ta.scrollHeight, 88), 176);
      ta.style.height = h + 'px';
      ta.style.overflowY = ta.scrollHeight > 176 ? 'auto' : 'hidden';
    };
    ta.addEventListener('input', grow);
    grow();
  }

  // ── Submit — touch every field, reveal all errors, block + scroll on failure ──
  formEl.addEventListener('submit', function (e) {
    var firstInvalid = null;
    FIELDS.forEach(function (name) {
      touched[name] = true;
      var msg = errorFor(name);
      if (msg) { showErr(name, msg); if (!firstInvalid) firstInvalid = field(name); }
      else hideErr(name);
    });
    refreshButton();
    if (firstInvalid) {
      e.preventDefault();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var foc = firstInvalid.querySelector('input, textarea, button');
      if (foc) setTimeout(function () { foc.focus(); }, 350);
    }
  });

  // ── Deep-link prefill (?topic=…&order=…&msg=…) — the account pages route
  //    here with context (order detail, edit details, delete account). Only
  //    known topics are accepted; nothing a visitor already typed is touched.
  (function () {
    var qp;
    try { qp = new URLSearchParams(window.location.search); } catch (e2) { return; }
    var qTopic = qp.get('topic');
    if (qTopic && topicInput && !topicInput.value) {
      var match = null;
      root.querySelectorAll('[data-contact-topic]').forEach(function (r) {
        if (r.getAttribute('data-contact-topic') === qTopic) match = r;
      });
      if (match) {
        topicInput.value = qTopic;
        if (topicLabel) { topicLabel.textContent = qTopic; topicLabel.classList.remove('is-placeholder'); }
        markCurrent(match);
        updateReveal(qTopic);
      }
    }
    var qOrder = qp.get('order');
    if (qOrder && reveal) {
      var oi = reveal.querySelector('input');
      if (oi && !oi.value) oi.value = qOrder.replace(/^#/, '');
    }
    var qMsg = qp.get('msg');
    var bodyTa = root.querySelector('textarea[name="contact[body]"]');
    if (qMsg && bodyTa && !bodyTa.value) {
      bodyTa.value = qMsg;
      bodyTa.dispatchEvent(new Event('input'));
    }
  })();

  refreshButton();
})();

/* ════════════════════════════════════════════════════════════
   FAQ — category switch (chips on mobile / rail on desktop) + a
   measured +/- accordion (one open per category), ported from v2
   faq.jsx. Isolated IIFE. Height is JS-measured (same technique as
   the footer accordion) so the max-height glide is exact.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-faq]');
  if (!root) return;

  function panes() { return root.querySelectorAll('[data-faq-pane]'); }
  function chips() { return root.querySelectorAll('[data-faq-chip]'); }
  function innerOf(item) { var b = item.querySelector('[data-faq-body]'); return b && b.firstElementChild; }

  function collapse(item) {
    var body = item.querySelector('[data-faq-body]');
    if (body) body.style.maxHeight = '0px';
    item.classList.remove('is-open');
    var q = item.querySelector('[data-faq-toggle]');
    if (q) q.setAttribute('aria-expanded', 'false');
  }
  function expand(item) {
    var body = item.querySelector('[data-faq-body]');
    var inner = innerOf(item);
    if (body && inner) body.style.maxHeight = inner.scrollHeight + 'px';
    item.classList.add('is-open');
    var q = item.querySelector('[data-faq-toggle]');
    if (q) q.setAttribute('aria-expanded', 'true');
  }
  function toggleItem(item) {
    if (!item) return;
    var pane = item.closest('[data-faq-pane]');
    var wasOpen = item.classList.contains('is-open');
    if (pane) pane.querySelectorAll('.lbd-faq-item.is-open').forEach(collapse); // one open per pane
    if (!wasOpen) expand(item);
  }

  function setActive(id) {
    panes().forEach(function (p) {
      var on = p.getAttribute('data-faq-pane') === id;
      if (on) p.removeAttribute('hidden');
      else { p.setAttribute('hidden', ''); p.querySelectorAll('.lbd-faq-item.is-open').forEach(collapse); }
    });
    chips().forEach(function (c) {
      var on = c.getAttribute('data-faq-chip') === id;
      c.setAttribute('aria-selected', on ? 'true' : 'false');
      c.classList.toggle('is-active', on);
    });
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-faq-chip]');
    if (chip && root.contains(chip)) { setActive(chip.getAttribute('data-faq-chip')); return; }
    var tog = e.target.closest('[data-faq-toggle]');
    if (tog && root.contains(tog)) { toggleItem(tog.closest('.lbd-faq-item')); return; }
  });

  // Keep an open answer's height correct across viewport / font reflow.
  window.addEventListener('resize', function () {
    root.querySelectorAll('.lbd-faq-item.is-open').forEach(function (item) {
      var body = item.querySelector('[data-faq-body]');
      var inner = innerOf(item);
      if (body && inner) body.style.maxHeight = inner.scrollHeight + 'px';
    });
  }, { passive: true });
})();

/* ════════════════════════════════════════════════════════════
   Exotic Leathers — single-open accordion index with measured
   natural height (v2 exotic-leathers.jsx LeatherRow). Isolated IIFE.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-leathers]');
  if (!root) return;

  function innerOf(item) { var b = item.querySelector('[data-leathers-body]'); return b && b.firstElementChild; }
  function measure(item) {
    var body = item.querySelector('[data-leathers-body]');
    var inner = innerOf(item);
    if (body && inner) body.style.maxHeight = inner.scrollHeight + 'px';
  }
  function collapse(item) {
    var body = item.querySelector('[data-leathers-body]');
    if (body) body.style.maxHeight = '0px';
    item.classList.remove('is-open');
    var t = item.querySelector('[data-leathers-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  function expand(item) {
    measure(item);
    item.classList.add('is-open');
    var t = item.querySelector('[data-leathers-toggle]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  root.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-leathers-toggle]');
    if (!tog || !root.contains(tog)) return;
    var item = tog.closest('.lbd-lea-item');
    if (!item) return;
    var wasOpen = item.classList.contains('is-open');
    root.querySelectorAll('.lbd-lea-item.is-open').forEach(collapse); // one open at a time
    if (!wasOpen) expand(item);
  });

  window.addEventListener('resize', function () {
    root.querySelectorAll('.lbd-lea-item.is-open').forEach(measure);
  }, { passive: true });
})();

/* ════════════════════════════════════════════════════════════
   Wishlist — real, persistent wishlist. No admin content, no demo rows.

   window.LBDWishlist: localStorage store keyed by PRODUCT HANDLE (one entry
   per product, so the bookmark state is stable across colour switches), with
   the viewed variant id kept for display. Emits `wishlist:change`.

   Two isolated consumers below:
     1. toggle  — any [data-wish-toggle] button (PDP bookmark) saves/removes
                  the current product; reads the live variant from the form.
     2. page    — the wishlist page hydrates itself from the store via the
                  Section Rendering API (/products/{handle}?section_id=…), so
                  every row is real Liquid with the real metafield mapping.
   ════════════════════════════════════════════════════════════ */
window.LBDWishlist = (function () {
  'use strict';
  var KEY = 'lbd:wishlist';
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: a.length } }));
  }
  function k(h) { return String(h); }
  return {
    list: read,
    count: function () { return read().length; },
    has: function (h) { h = k(h); return read().some(function (x) { return k(x.h) === h; }); },
    add: function (h, v) {
      h = k(h); var a = read();
      if (!a.some(function (x) { return k(x.h) === h; })) { a.unshift({ h: h, v: v ? String(v) : '' }); write(a); }
    },
    remove: function (h) { h = k(h); write(read().filter(function (x) { return k(x.h) !== h; })); },
    toggle: function (h, v) { if (this.has(h)) { this.remove(h); return false; } this.add(h, v); return true; }
  };
})();

/* 1. Toggle — bookmark buttons anywhere (PDP). Isolated IIFE. */
(function () {
  'use strict';
  var W = window.LBDWishlist;
  if (!W) return;

  function variantOf(btn) {
    if (btn.getAttribute('data-wish-variant')) return btn.getAttribute('data-wish-variant');
    var form = btn.closest('form');
    var input = form && form.querySelector('[name="id"]');
    // PDP: the gallery bookmark sits OUTSIDE the product form — read the
    // live selected variant from the page's product form instead.
    if (!input) input = document.querySelector('[data-product-root] [name="id"]');
    return input ? input.value : '';
  }
  function reflect(btn) {
    var on = W.has(btn.getAttribute('data-wish-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-saved', on);
  }
  function reflectAll() {
    document.querySelectorAll('[data-wish-toggle]').forEach(reflect);
    // Menu caption — count is localStorage-backed, so it works signed out too.
    var navSub = document.querySelector('[data-wish-navsub]');
    if (navSub) {
      var n = W.count();
      navSub.textContent = n === 0 ? 'No saved pieces yet' : (n === 1 ? '1 saved piece' : n + ' saved pieces');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-wish-handle');
    if (!h) return;
    W.toggle(h, variantOf(btn));
    reflect(btn);
  });

  document.addEventListener('wishlist:change', reflectAll);
  reflectAll();
})();

/* 2. Wishlist page — hydrate rows from the store via Section Rendering API,
   remove, add-to-bag, empty state. Isolated IIFE. */
(function () {
  'use strict';
  var W = window.LBDWishlist;
  var root = document.querySelector('[data-wishlist]');
  if (!W || !root) return;

  var list = root.querySelector('[data-wish-list]');
  var empty = root.querySelector('[data-wish-empty]');
  var loading = root.querySelector('[data-wish-loading]');
  var countEl = root.querySelector('[data-wish-count]');
  var wordEl = root.querySelector('[data-wish-word]');
  var subs = root.querySelectorAll('[data-wish-sub]');
  var section = root.getAttribute('data-wish-section') || 'wishlist-row';

  function show(el, on) { if (el) el.hidden = !on; }
  function setEmpty(isEmpty) {
    show(empty, isEmpty);
    show(list, !isEmpty);
    subs.forEach(function (s) { s.hidden = isEmpty; });
    document.dispatchEvent(new CustomEvent('fvs:relock'));   // re-measure the full-viewport stage
  }
  function setMeta(n) {
    if (countEl) countEl.textContent = n;
    if (wordEl) wordEl.textContent = n === 1 ? 'Item' : 'Items';
  }
  // Forward preview_theme_id when previewing an unpublished theme, so the row
  // section renders from the SAME theme as the page (not the live theme).
  function previewParam() {
    var m = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    return m ? '&preview_theme_id=' + m[1] : '';
  }
  function rowUrl(item) {
    var u = '/products/' + encodeURIComponent(item.h) + '?section_id=' + encodeURIComponent(section);
    if (item.v) u += '&variant=' + encodeURIComponent(item.v);
    return u + previewParam();
  }

  function hydrate() {
    var items = W.list();
    setMeta(items.length);
    if (!items.length) { show(loading, false); setEmpty(true); return; }

    show(empty, false);
    subs.forEach(function (s) { s.hidden = false; });
    show(loading, true);
    show(list, false);

    Promise.all(items.map(function (item) {
      return fetch(rowUrl(item), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          // Drop an entry ONLY on a definite 404 (product gone). A transient
          // failure (offline, 429 from the parallel burst, 5xx) must never
          // erase the saved wishlist — skip the row this load, keep the entry.
          if (r.ok) return r.text().then(function (t) { return { item: item, html: t, gone: false }; });
          return { item: item, html: '', gone: r.status === 404 };
        })
        .catch(function () { return { item: item, html: '', gone: false }; });
    })).then(function (results) {
      if (list) list.innerHTML = '';
      results.forEach(function (res) {
        if (!res.html) { if (res.gone) W.remove(res.item.h); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = res.html;
        var row = tmp.querySelector('[data-wish-row]');
        if (row && list) list.appendChild(row);
      });
      show(loading, false);
      var n = W.count();
      setMeta(n);
      if (!list || !list.children.length) { setEmpty(true); }
      else { setEmpty(false); }
    });
  }

  // Remove (bookmark on a row)
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-remove]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var row = btn.closest('[data-wish-row]');
    if (!row || row.classList.contains('is-removing')) return;
    var h = row.getAttribute('data-wish-handle');
    if (h) W.remove(h);
    row.classList.add('is-removing');
    window.setTimeout(function () {
      if (row.parentNode) row.parentNode.removeChild(row);
      var n = W.count();
      setMeta(n);
      if (n === 0) setEmpty(true);
    }, 200);
  });

  // Add to bag (from a row)
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-add]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant');
    if (!vid || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { btn.disabled = false; return; }
      // Go to the cart — same as the PDP "Add to bag" (native form → /cart) and
      // Buy it Now (→ /checkout); the site has no mini-drawer, so a silent add
      // read as "nothing happened". Carry the preview theme id when previewing.
      var pp = previewParam();
      window.location.href = '/cart' + (pp ? '?' + pp.slice(1) : '');
    }).catch(function () { btn.disabled = false; });
  });

  hydrate();
})();

/* FullViewportStage (v2 M6) — a single-message system state (empty / not-found
   / success) fills the viewport below its own top, content optically centred
   (8% upward bias). Height is locked in px on mount and on WIDTH-resize only
   (never vh — iOS dynamic-viewport churn must not move it). Any [data-fvs]
   element opts in; re-lock after it is shown via the fvs:relock event.
   Isolated IIFE — reusable by cart / search / 404 empties later. */
(function () {
  'use strict';
  function lock() {
    document.querySelectorAll('[data-fvs]').forEach(function (el) {
      if (el.hidden || el.offsetParent === null) { el.style.minHeight = ''; el.style.paddingBottom = ''; return; }
      var top = el.getBoundingClientRect().top + window.pageYOffset;
      var h = Math.max(240, Math.round(window.innerHeight - top));
      el.style.minHeight = h + 'px';
      el.style.paddingBottom = Math.round(h * 0.08) + 'px';
    });
  }
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;   // height-only churn (iOS): ignore
    lastW = window.innerWidth;
    lock();
  }, { passive: true });
  document.addEventListener('fvs:relock', lock);
  lock();
})();

/* ════════════════════════════════════════════════════════════
   Cart page — real cart interactions (v2 cart.jsx). Quantity stepper and
   remove run over /cart/change.js, then the whole section re-renders via the
   Section Rendering API so items, meta, summary and the empty state always
   agree with the live cart. Personalized lines carry data-keys with BOTH
   linked line keys (case + hidden initials surcharge) — removed together.
   Promo codes apply over the Cart AJAX API with inline validation (applied
   codes render as removable chips; invalid codes report inline, never reach
   checkout). Isolated IIFE.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart]');
  if (!root) return;
  var sectionId = root.getAttribute('data-cart-section');

  function previewParam(prefix) {
    var m = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    return m ? prefix + 'preview_theme_id=' + m[1] : '';
  }
  function busy(on) { root.classList.toggle('is-busy', on); }

  // Initials surcharge lines are hidden plumbing (folded into their case line
  // in this cart) — the badge counts PIECES, so their quantities are excluded.
  function visibleCount(c) {
    var n = c.item_count || 0;
    (c.items || []).forEach(function (it) { if ((it.handle || '').indexOf('initials') >= 0) n -= it.quantity; });
    return n;
  }
  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function refresh() {
    return fetch('/cart?section_id=' + encodeURIComponent(sectionId) + previewParam('&'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart]');
        if (fresh) root.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('fvs:relock'));
      });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // Discount codes over the Cart AJAX API (Shopify-native, no redirect). The
  // `discount` field REPLACES the cart's code set; the returned cart carries
  // discount_codes[{ code, applicable }] so we can validate inline.
  function updateDiscount(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes })
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  function appliedCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }
  function promoMsg(text, kind) {
    var el = root.querySelector('[data-cart-promo-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', kind === 'error');
    el.classList.toggle('is-ok', kind === 'ok');
    el.hidden = !text;
  }

  root.addEventListener('click', function (e) {
    // Quantity − / + (clamped at 1; removal only via the ×, as v2)
    var step = e.target.closest('[data-cart-qty]');
    if (step) {
      var q = parseInt(step.getAttribute('data-qty'), 10) || 1;
      var next = Math.max(1, q + (parseInt(step.getAttribute('data-delta'), 10) || 0));
      if (next === q) return;
      busy(true);
      change(step.getAttribute('data-key'), next)
        .then(function (c) { paintCount(visibleCount(c)); return refresh(); })
        .catch(function () {})
        .then(function () { busy(false); });
      return;
    }

    // Remove — deletes every linked key (case + initials surcharge)
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      var keys = (rm.getAttribute('data-keys') || '').split(',').filter(Boolean);
      if (!keys.length) return;
      busy(true);
      (function next(i, cartJson) {
        if (i >= keys.length) {
          if (cartJson) paintCount(visibleCount(cartJson));
          refresh().then(function () { busy(false); });
          return;
        }
        change(keys[i], 0)
          .then(function (c) { next(i + 1, c); })
          .catch(function () { next(i + 1, cartJson); });
      })(0, null);
      return;
    }

    // Promo accordion
    var tog = e.target.closest('[data-cart-promo-toggle]');
    if (tog) {
      var box = tog.closest('[data-cart-promo]');
      var open = box.classList.toggle('is-open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      var sign = box.querySelector('.lbd-cartp-promosign');
      if (sign) sign.textContent = open ? '–' : '+';
      if (open) { var inp = box.querySelector('[data-cart-promo-input]'); if (inp) inp.focus(); }
      return;
    }

    // Promo apply — Cart AJAX API + inline validation (no redirect). A new code
    // is ADDED to the applied set (an auto/shared code already on the cart must
    // survive a manual entry); if it's rejected we restore the previous set,
    // so a bad entry never wipes a good code.
    var ap = e.target.closest('[data-cart-promo-apply]');
    if (ap) {
      var input = root.querySelector('[data-cart-promo-input]');
      var code = input && input.value.trim();
      if (!code) { if (input) input.focus(); return; }
      var lc = code.toLowerCase();
      promoMsg('', ''); busy(true);
      getCart().then(function (prev) {
        var prevCodes = appliedCodes(prev);
        if (prevCodes.some(function (c) { return c.toLowerCase() === lc; })) {
          promoMsg('That code is already applied.', 'ok'); busy(false); return;
        }
        return updateDiscount(prevCodes.concat(code).join(',')).then(function (cart) {
          var entry = (cart.discount_codes || []).filter(function (d) { return (d.code || '').toLowerCase() === lc; })[0];
          if (entry && entry.applicable) {
            return refresh().then(function () { promoMsg('Code applied.', 'ok'); busy(false); });
          }
          // Rejected — restore the previously-applied set (drops the bad code so
          // it never reaches checkout) and report inline.
          return updateDiscount(prevCodes.join(',')).then(function () {
            promoMsg('That code isn’t valid or has expired.', 'error');
            busy(false);
            if (input) input.focus();
          });
        });
      }).catch(function () {
        promoMsg('Couldn’t apply the code. Please try again.', 'error');
        busy(false);
      });
      return;
    }

    // Promo remove — drop one applied code, keep the rest.
    var rmp = e.target.closest('[data-cart-promo-remove]');
    if (rmp) {
      var rmcode = (rmp.getAttribute('data-cart-promo-remove') || '').toLowerCase();
      busy(true);
      getCart().then(function (c) {
        var keep = appliedCodes(c).filter(function (code) { return code.toLowerCase() !== rmcode; });
        return updateDiscount(keep.join(',')).then(function () { return refresh(); });
      }).catch(function () {}).then(function () { busy(false); });
      return;
    }
  });

  // Enter in the promo field applies it
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-cart-promo-input]');
    if (!input) return;
    e.preventDefault();
    var ap = root.querySelector('[data-cart-promo-apply]');
    if (ap) ap.click();
  });
})();

/* ════════════════════════════════════════════════════════════
   Search overlay (v2 search.jsx) — live search-as-you-type. The header
   magnifier toggles the overlay (mobile full-screen / desktop drop panel);
   the query is debounced and fetched through the Section Rendering API
   (sections/search-grid → real results, canonical product cards). States:
   EMPTY (chips + trending) / RESULTS / NO RESULTS, cross-faded like v2.
   Esc, scrim and × close; body scroll locks while open. Isolated IIFE.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-search]');
  if (!root) return;

  var input = root.querySelector('[data-se-input]');
  var clearBtn = root.querySelector('[data-se-clear]');
  var states = root.querySelector('[data-se-states]');
  var elEmpty = root.querySelector('[data-se-empty]');
  var elResults = root.querySelector('[data-se-results]');
  var elNores = root.querySelector('[data-se-nores]');
  var noresQ = root.querySelector('[data-se-noresq]');

  var timer = null;
  var ctrl = null;
  var phase = 'empty';

  function previewParam() {
    var m = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    return m ? '&preview_theme_id=' + m[1] : '';
  }

  // ── Panel anchor — the LIVE bottom edge of the header chrome (announcement
  // strip included); a static --header-height would crowd the field into the
  // strip at scroll-top. ──
  function anchor() {
    var header = document.querySelector('.lbd-header');
    if (!header) return;
    var b = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    root.style.setProperty('--se-top', b + 'px');
  }
  window.addEventListener('resize', function () { if (isOpen()) anchor(); }, { passive: true });
  window.addEventListener('scroll', function () { if (isOpen()) anchor(); }, { passive: true });

  // ── Open / close ──
  function open() {
    anchor();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lbd-se-lock');
    window.setTimeout(function () { if (input) input.focus(); }, 60);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lbd-se-lock');
  }
  function isOpen() { return root.classList.contains('is-open'); }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-se-open]');
    if (opener) {
      e.preventDefault();
      if (isOpen()) { close(); } else { open(); }
      return;
    }
    var closer = e.target.closest('[data-se-close]');
    if (closer && root.contains(closer)) { close(); }
  });
  root.querySelector('.lbd-se-scrim').addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // ── State machine with the v2 cross-fade ──
  function show(next) {
    if (next === phase) return;
    phase = next;
    states.classList.add('is-fading');
    window.setTimeout(function () {
      elEmpty.hidden = next !== 'empty';
      elResults.hidden = next !== 'results';
      elNores.hidden = next !== 'nores';
      states.classList.remove('is-fading');
    }, 120);
  }

  // ── Live query ──
  function runSearch(q) {
    if (ctrl) ctrl.abort();
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    var url = '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=search-grid' + previewParam();
    fetch(url, { signal: ctrl && ctrl.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // A newer query may have started while this one was in flight.
        if (input.value.trim() !== q) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var grid = tmp.querySelector('[data-se-grid]');
        var count = grid ? parseInt(grid.getAttribute('data-count'), 10) || 0 : 0;
        if (count > 0) {
          elResults.innerHTML = grid.innerHTML;
          show('results');
        } else {
          if (noresQ) noresQ.textContent = q;
          show('nores');
        }
      })
      .catch(function () { /* aborted or offline — keep the current state */ });
  }

  function onInput() {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = input.value.length === 0;
    if (timer) window.clearTimeout(timer);
    if (!q) { if (ctrl) ctrl.abort(); show('empty'); return; }
    timer = window.setTimeout(function () { runSearch(q); }, 280);
  }
  input.addEventListener('input', onInput);
  // Committed searches go STRICT: every term quoted → Shopify requires ALL
  // terms literally, killing the expanded/partial-match padding. The overlay's
  // live fetch above stays loose (prefix matching while typing needs it).
  // KEEP IN SYNC with the copy in the [data-sep] page IIFE.
  function strictQuery(q) {
    var toks = q.match(/"[^"]*"|\S+/g) || [];
    return toks.map(function (t) { return t.charAt(0) === '"' ? t : '"' + t.replace(/"/g, '') + '"'; }).join(' ');
  }
  input.addEventListener('keydown', function (e) {
    // Enter → the full search page (the overlay is the quick layer).
    if (e.key !== 'Enter') return;
    var q = input.value.trim();
    if (!q) return;
    e.preventDefault();
    window.location.href = '/search?q=' + encodeURIComponent(strictQuery(q)) + '&type=product';
  });

  if (clearBtn) clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    if (ctrl) ctrl.abort();
    show('empty');
    input.focus();
  });

  // Popular chips (both copies — empty state + no-results) run the query.
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-se-chip]');
    if (!chip) return;
    input.value = chip.textContent.trim();
    if (clearBtn) clearBtn.hidden = false;
    runSearch(input.value.trim());
    input.focus();
  });
})();

/* ════════════════════════════════════════════════════════════
   Limited Series collection pages (v2 edition-black.jsx). Chip quick-filter
   (row + mobile sheet share data-pop-chip), the sticky mobile compact bar,
   and the divider layout: mobile = an inset hairline between consecutive
   visible cards; desktop = a full-width hairline between rows of the
   two-column grid, with the small cross tick ONLY at nodes where four
   pieces meet (divider between two full rows — the collection's signature).
   Isolated IIFE.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var root = document.querySelector('[data-pop]');
  if (!root) return;

  var list = root.querySelector('[data-pop-list]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pop-piece]'));
  var chiprow = root.querySelector('[data-pop-chiprow]');
  var compact = root.querySelector('[data-pop-compactbar]');
  var compactLabel = root.querySelector('[data-pop-compact-label]');
  var countEl = root.querySelector('[data-pop-count]');
  var wordEl = root.querySelector('[data-pop-word]');
  var mqDesktop = window.matchMedia(window.LBD_DESKTOP_MQ);
  var active = 'all';

  function visibleCards() {
    return cards.filter(function (c) { return !c.hidden; });
  }

  // Rebuild dividers for the current visibility set + breakpoint.
  function layout() {
    list.querySelectorAll('.lbd-pop-div').forEach(function (d) { d.remove(); });
    var vis = visibleCards();
    var step = mqDesktop.matches ? 2 : 1;
    for (var i = step; i < vis.length; i += step) {
      var div = document.createElement('div');
      div.className = 'lbd-pop-div';
      div.setAttribute('aria-hidden', 'true');
      // Cross only where four pieces meet: the row ABOVE is always full (we cut
      // at multiples of two), so the node exists iff the row BELOW is full too.
      if (mqDesktop.matches && vis.length - i >= 2) div.classList.add('has-cross');
      list.insertBefore(div, vis[i]);
    }
  }

  function applyFilter(value) {
    active = value;
    cards.forEach(function (c) {
      c.hidden = value !== 'all' && c.getAttribute('data-pop-cat') !== value;
    });
    root.querySelectorAll('[data-pop-chip]').forEach(function (ch) {
      ch.setAttribute('aria-selected', ch.getAttribute('data-pop-chip') === value ? 'true' : 'false');
    });
    var n = visibleCards().length;
    if (countEl) countEl.textContent = n;
    if (wordEl) wordEl.textContent = n === 1 ? 'Piece' : 'Pieces';
    if (compactLabel) compactLabel.textContent = value === 'all' ? 'All' : value;
    layout();
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-pop-chip]');
    if (!chip) return;
    applyFilter(chip.getAttribute('data-pop-chip'));
    // Picking from the mobile sheet applies AND closes it.
    var sheet = chip.closest('[data-sheet]');
    if (sheet) { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); window.__lbdReleaseLock(); }
  });

  // Mobile compact bar — slides in once the chip row scrolls under the header.
  function headerBottom() {
    var h = document.querySelector('.lbd-header');
    return h ? h.getBoundingClientRect().bottom : 0;
  }
  function onScroll() {
    if (!compact || !chiprow || mqDesktop.matches) return;
    var show = chiprow.getBoundingClientRect().bottom <= headerBottom();
    compact.classList.toggle('is-shown', show);
    compact.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });

  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    layout();
    onScroll();
  }, { passive: true });

  layout();
  onScroll();
})();

/* Search results PAGE field — the same clear × as the overlay (appears only
   with text, same spot). Isolated IIFE. */
(function () {
  'use strict';
  var input = document.querySelector('[data-sep-input]');
  var btn = document.querySelector('[data-sep-clear]');
  if (!input || !btn) return;
  input.addEventListener('input', function () { btn.hidden = input.value.length === 0; });
  btn.addEventListener('click', function () {
    input.value = '';
    btn.hidden = true;
    input.focus();
  });

  // Strict commit — same rule as the overlay's Enter (KEEP IN SYNC): quote every
  // term so Shopify requires all of them and skips the expanded-match padding.
  // No-JS falls back to the loose (raw) query — degraded but functional.
  function strictQuery(q) {
    var toks = q.match(/"[^"]*"|\S+/g) || [];
    return toks.map(function (t) { return t.charAt(0) === '"' ? t : '"' + t.replace(/"/g, '') + '"'; }).join(' ');
  }
  var form = document.querySelector('[data-sep-form]');
  if (form) form.addEventListener('submit', function () {
    var q = input.value.trim();
    if (q) input.value = strictQuery(q);
  });

  // Close-matches tier: the strict query found nothing → fetch the LOOSE run
  // through the search-grid section (same endpoint the overlay uses) and swap
  // it in under the "No exact matches" note. The server-rendered link inside
  // the container is the no-JS / fetch-failure path.
  var closeWrap = document.querySelector('[data-sep-close]');
  if (closeWrap) {
    var looseQ = closeWrap.getAttribute('data-close-q') || '';
    if (looseQ) {
      var url = '/search?q=' + encodeURIComponent(looseQ) + '&type=product&section_id=search-grid' +
        (window.location.search.match(/[?&]preview_theme_id=(\d+)/) ? '&preview_theme_id=' + window.location.search.match(/[?&]preview_theme_id=(\d+)/)[1] : '');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var grid = tmp.querySelector('[data-se-grid]');
          if (!grid || parseInt(grid.getAttribute('data-count'), 10) < 1) return;
          // The tier's view-all must open the LOOSE results page (the section's
          // own link commits strict, which would loop back to zero results).
          var va = grid.querySelector('.lbd-se-viewall a');
          if (va) va.setAttribute('href', '/search?q=' + encodeURIComponent(looseQ) + '&type=product');
          closeWrap.innerHTML = '';
          closeWrap.appendChild(grid);
          closeWrap.classList.add('is-filled');
        })
        .catch(function () {});
    }
  }
})();

/* Cookie consent — the v2 surface (mobile bottom bar / desktop corner card)
   over Shopify's Customer Privacy API, the platform consent bus the built-in
   banner, consent apps and Shopify pixels all share. We only replace the
   banner UI: visibility asks the API (shouldShowBanner — region rules come
   from Settings → Customer privacy), choices are written back with
   setTrackingConsent. localStorage mirrors the choice as a fallback for
   previews where the API is unavailable. Isolated IIFE. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ck]');
  if (!root) return;
  var card = root.querySelector('[data-ck-card]');
  var inner = root.querySelector('[data-ck-inner]');
  var consent = root.querySelector('[data-ck-consent]');
  var prefs = root.querySelector('[data-ck-prefs]');
  if (!card || !inner || !consent || !prefs) return;

  var KEY = 'lbd:cookie-consent';
  function stored() { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } }
  function remember(v) { try { window.localStorage.setItem(KEY, v); } catch (e) {} }

  function withPrivacy(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) { cb(S.customerPrivacy); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(!err && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
      });
      return;
    }
    cb(null);
  }

  // Announce the outcome ONCE, both ways, so anything queued behind consent
  // knows where it stands instead of guessing on a timer. 'open' = the banner
  // is up and a choice is owed; 'idle' = it will not appear at all (consent
  // already recorded, or not required in this region). The promo popup used to
  // probe `.is-open` at 2s while this banner can still decide to open at 3.5s,
  // so it concluded "no banner" before the banner had decided — and both landed
  // on screen, the promo covering the banner it is meant to yield to.
  // The attribute is for latecomers; the event is for anyone already listening.
  function settle(state) {
    if (root.getAttribute('data-ck-state')) return;   // first outcome wins
    root.setAttribute('data-ck-state', state);
    if (state === 'idle') window.dispatchEvent(new CustomEvent('lbd-cookie-idle'));
  }

  function open() {
    settle('open');
    root.setAttribute('aria-hidden', 'false');
    // Double rAF: let the closed transform paint first so the slide-in runs.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
  }

  function close() {
    root.classList.add('is-leaving');
    root.classList.remove('is-prefs');
    window.setTimeout(function () {
      root.classList.remove('is-open', 'is-leaving');
      root.setAttribute('aria-hidden', 'true');
      card.style.height = '';
      consent.hidden = false;
      prefs.hidden = true;
    }, 260);
    window.dispatchEvent(new CustomEvent('lbd-cookie-dismissed'));
  }

  // Consent ↔ preferences swap in the same bottom-anchored card — measured
  // height transition, so the surface grows upward (v2 corner-card behavior).
  function swap(showPrefs) {
    var from = card.getBoundingClientRect().height;
    consent.hidden = showPrefs;
    prefs.hidden = !showPrefs;
    root.classList.toggle('is-prefs', showPrefs);
    card.style.height = 'auto';
    var to = card.getBoundingClientRect().height;
    card.style.height = from + 'px';
    void card.offsetHeight;
    card.style.height = to + 'px';
    window.setTimeout(function () { card.style.height = ''; }, 320);
  }

  // Save is inert until the visitor expresses something: any pill touch —
  // even toggling one on and back off — is an explicit "essential only"
  // decision, so from the first touch Save stays live (saving with all
  // pills off is a valid choice, equal to Reject; it must stay one tap).
  var save = root.querySelector('[data-ck-save]');
  var touched = false;
  function updateSave() {
    if (!save) return;
    var anyOn = root.querySelector('[data-ck-pill].is-on:not([aria-disabled="true"])');
    save.setAttribute('aria-disabled', touched || anyOn ? 'false' : 'true');
  }

  root.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-ck-pill]');
    if (pill && pill.getAttribute('aria-disabled') !== 'true') {
      var on = !pill.classList.contains('is-on');
      pill.classList.toggle('is-on', on);
      pill.setAttribute('aria-checked', on ? 'true' : 'false');
      touched = true;
      updateSave();
      return;
    }
    if (e.target.closest('[data-ck-customize]')) { swap(true); return; }
    if (e.target.closest('[data-ck-close]')) { swap(false); return; }
    if (e.target.closest('[data-ck-accept]')) { decide(true, true); return; }
    if (e.target.closest('[data-ck-reject]')) { decide(false, false); return; }
    if (e.target.closest('[data-ck-save]')) {
      if (save && save.getAttribute('aria-disabled') === 'true') return;
      var a = root.querySelector('[data-ck-pill="analytics"]');
      var m = root.querySelector('[data-ck-pill="marketing"]');
      decide(!!(a && a.classList.contains('is-on')), !!(m && m.classList.contains('is-on')));
    }
  });
  updateSave();

  // Cookie-Script (the paid CMP, GTM-injected) is the consent engine of
  // record; OUR surface drives it through its public API. Its own banner is
  // hidden via CSS (#cookiescript_injected_wrapper). Categories map:
  // Analytics pill → performance + functionality, Marketing → targeting;
  // strict (essential) is always on. Shopify's consent bus is still written
  // in parallel so native pixels/analytics follow the same choice.
  function csApi() {
    return (window.CookieScript && window.CookieScript.instance) || null;
  }
  function decide(analytics, marketing) {
    remember(JSON.stringify({ analytics: analytics, marketing: marketing }));
    var cs = csApi();
    if (cs) {
      try {
        if (analytics && marketing && typeof cs.acceptAllAction === 'function') cs.acceptAllAction();
        else if (!analytics && !marketing && typeof cs.rejectAllAction === 'function') cs.rejectAllAction();
        else if (typeof cs.acceptAction === 'function') {
          var cats = [];
          if (analytics) { cats.push('performance'); cats.push('functionality'); }
          if (marketing) { cats.push('targeting'); }
          cs.acceptAction(cats);
        }
      } catch (e) { /* CMP hiccup — the mirrors below still record the choice */ }
    }
    withPrivacy(function (api) {
      if (api && typeof api.setTrackingConsent === 'function') {
        try {
          api.setTrackingConsent({
            analytics: analytics,
            marketing: marketing,
            preferences: analytics,
            sale_of_data: marketing
          }, function () {});
        } catch (e) { /* consent bus unavailable — localStorage mirror stands */ }
      }
    });
    close();
  }

  // Preview hook: ?ck-preview forces the banner open (bypasses the consent
  // API and any stored choice) so the design can be checked from any region.
  if (window.location.search.indexOf('ck-preview') !== -1) {
    window.setTimeout(open, 400);
    return;
  }

  // Visibility — Cookie-Script first (the engine of record): banner shows
  // while its currentState() carries no action yet. The CMP arrives late via
  // GTM, so wait for its load event with a timeout; if it never turns up
  // (theme preview, GTM blocked) fall back to the Shopify consent API /
  // localStorage chain so the banner still behaves.
  var decided = false;
  function showFromCs() {
    var cs = csApi();
    if (!cs || typeof cs.currentState !== 'function') return null;
    try {
      var st = cs.currentState();
      return !(st && st.action);   // no action recorded yet → banner due
    } catch (e) { return null; }
  }
  function fallbackShow() {
    withPrivacy(function (api) {
      var show;
      if (api && typeof api.shouldShowBanner === 'function') {
        try { show = api.shouldShowBanner(); } catch (e) { show = !stored(); }
      } else {
        show = !stored();
      }
      if (show) open(); else settle('idle');
    });
  }
  function evaluate() {
    if (decided) return;
    var cs = showFromCs();
    if (cs === null) return;       // CMP not ready — keep waiting
    decided = true;
    if (cs) open(); else settle('idle');
  }
  window.addEventListener('CookieScriptLoaded', function () { window.setTimeout(evaluate, 100); });
  window.setTimeout(evaluate, 900);            // CMP may already be up
  window.setTimeout(function () {
    if (decided) return;
    decided = true;
    var cs = showFromCs();
    // Cookie-Script is the engine of record: when it says the banner is due,
    // OPEN. This used to hand over to fallbackShow(), which re-asked Shopify —
    // and Shopify's shouldShowBanner() is region-gated, so a "yes" from the CMP
    // could be vetoed by a "no" from the secondary gate and no banner appeared
    // at all. Only a CMP that never turned up (theme preview, GTM blocked)
    // falls through to the Shopify / localStorage chain.
    if (cs === true) { open(); return; }
    if (cs === null) { fallbackShow(); return; }
    settle('idle');              // cs === false — a choice is already recorded
  }, 3500);
})();

/* Promo popup — the v2 PromoBanner surface (one slot, three formats: FULL /
   DOCKED / EMAIL) with production orchestration. Never competes with the
   cookie banner: waits for `lbd-cookie-dismissed` (or for the cookie banner
   to not show at all), then opens after the section's delay. A close is
   remembered for N days (localStorage). EMAIL submits over the live store's
   Klaviyo backbone (client subscriptions API; company id auto-read from the
   klaviyo.js app embed, list id from the section) and falls back to
   Shopify's native customer signup so no address is ever lost. Re-inits on
   shopify:section:load so the theme editor stays live. ?promo-preview
   force-opens. Isolated IIFE. */
(function () {
  'use strict';
  var mqDesktop = window.matchMedia(window.LBD_DESKTOP_MQ);
  var KEY_DISMISS = 'lbd:promo-dismissed';
  var KEY_SUB = 'lbd:promo-subscribed';

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function initPromo(root) {
    var fmt = root.getAttribute('data-format');
    var card = root.querySelector('[data-promo-card]');
    if (!fmt || !card) return;
    var delay = parseFloat(root.getAttribute('data-delay')) || 0;
    var freq = parseFloat(root.getAttribute('data-freq')) || 30;
    var design = root.hasAttribute('data-design');
    var preview = window.location.search.indexOf('promo-preview') !== -1;
    var openState = false;
    var closed = false;      // once dismissed, never reopens this pageview
    var pendingOpen = null;

    function lock(on) {
      var wants = fmt === 'full' || (fmt === 'email' && !mqDesktop.matches);
      if (wants) document.body.style.overflow = on ? 'hidden' : '';
    }

    function open() {
      if (openState || closed) return;
      openState = true;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      lock(true);
    }

    function dismiss(remember) {
      if (!openState) return;
      openState = false;
      closed = true;
      if (pendingOpen) { window.clearTimeout(pendingOpen); pendingOpen = null; }
      if (remember !== false) lsSet(KEY_DISMISS, String(Date.now()));
      lock(false);
      root.classList.add('is-leaving');
      window.setTimeout(function () {
        root.classList.remove('is-open', 'is-leaving');
        root.setAttribute('aria-hidden', 'true');
      }, 350);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]')) { dismiss(); return; }
      if (e.target.closest('[data-promo-cta]')) { lsSet(KEY_DISMISS, String(Date.now())); return; }
      if (e.target === root.querySelector('[data-promo-scrim]')) dismiss();
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openState && fmt === 'full' && mqDesktop.matches) dismiss();
    });

    // ---- EMAIL: Klaviyo client API first, native Shopify signup fallback.
    var form = root.querySelector('[data-nl-form]');
    if (form) {
      var emailInput = root.querySelector('[data-nl-email]');
      var errEl = root.querySelector('[data-nl-err]');
      var bodyEl = root.querySelector('[data-nl-body]');
      var thanksEl = root.querySelector('[data-nl-thanks]');

      var klaviyoCompany = function () {
        var c = root.getAttribute('data-klaviyo-company');
        if (c) return c;
        var s = document.querySelector('script[src*="static.klaviyo.com/onsite/js"]');
        if (s) {
          var m = s.src.match(/[?&]company_id=([A-Za-z0-9]+)/) ||
                  s.src.match(/onsite\/js\/([A-Za-z0-9]{6,7})\/klaviyo\.js/);
          if (m) return m[1];
        }
        return '';
      };

      var klaviyoSubscribe = function (email, company, list) {
        return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Promo popup',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
      };

      var nativeSubscribe = function () {
        var body = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { body.append(k, v); });
        return window.fetch(form.action, { method: 'POST', body: body, headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (r.url && r.url.indexOf('challenge') !== -1) { var er = new Error('challenge'); er.challenge = true; throw er; }
            if (!r.ok) throw new Error('native ' + r.status);
          });
      };

      var showThanks = function () {
        if (bodyEl) bodyEl.hidden = true;
        if (thanksEl) thanksEl.hidden = false;
        lsSet(KEY_SUB, '1');
        lsSet(KEY_DISMISS, String(Date.now()));
      };

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput && emailInput.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (emailInput) emailInput.focus(); return; }
        if (errEl) errEl.hidden = true;
        // Mark the promo as handled BEFORE any network/navigation: the native
        // fallback may leave the page (bot challenge, cross-domain redirect),
        // and without this the popup re-opened after the reload.
        lsSet(KEY_DISMISS, String(Date.now()));
        var company = klaviyoCompany();
        var list = root.getAttribute('data-klaviyo-list');
        var flow = (company && list)
          ? klaviyoSubscribe(email, company, list).catch(function () { return nativeSubscribe(); })
          : nativeSubscribe();
        flow.then(showThanks).catch(function (er) {
          // challenge → the real form POST lets Shopify run its bot check;
          // TypeError → fetch was killed by a cross-origin redirect (e.g. the
          // myshopify.com preview domain forwarding to the primary domain) —
          // a real form POST follows that redirect natively, so hand over.
          if (er && (er.challenge || er.name === 'TypeError')) { form.submit(); return; }
          if (errEl) errEl.hidden = false;
        });
      });
    }

    // ---- Visibility gates.
    if (design || preview) { window.setTimeout(open, 300); return; }
    if (fmt === 'email' && lsGet(KEY_SUB)) return;
    var ts = parseInt(lsGet(KEY_DISMISS), 10);
    if (ts && (Date.now() - ts) < freq * 86400000) return;

    var armed = false;
    function arm() {
      if (armed) return;
      armed = true;
      pendingOpen = window.setTimeout(open, delay * 1000);
    }
    // The promo never competes with the cookie banner. Two ways to learn that
    // the coast is clear, both announced by the banner itself: it was answered
    // and closed, or it settled without ever appearing (consent already on
    // file, or not required here).
    window.addEventListener('lbd-cookie-dismissed', arm);
    window.addEventListener('lbd-cookie-idle', arm);
    var ckEl = document.querySelector('[data-ck]');
    if (!ckEl) {
      // No cookie banner on this page (section disabled) — nothing to yield to.
      arm();
    } else {
      // Safety net for a banner that never settles at all: malformed markup, a
      // section that failed to init. Deliberately well AFTER the banner's own
      // last decision point (3.5s, and its Shopify-API fallback resolves async
      // some way past that) — probing earlier is what used to let the promo
      // conclude "no banner" while the banner was still deciding, and then
      // cover the banner it exists to yield to. A banner that IS up is never
      // overridden: the promo waits for the visitor's choice, however long.
      window.setTimeout(function () {
        if (ckEl.getAttribute('data-ck-state') === 'open') return;
        arm();
      }, 7000);
    }
  }

  var el = document.querySelector('[data-promo]');
  if (el) initPromo(el);

  // Theme editor: sections re-render on every setting change.
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-promo]') : null;
    if (r) { document.body.style.overflow = ''; initPromo(r); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-promo]')) {
      document.body.style.overflow = '';
    }
  });
})();

/* Account auth — v2 account.jsx mechanics over Shopify's customer forms.
   Mode switching on /account/login (signin ↔ forgot; forgot-success is a
   server state via recover_success), password eye reveals, and client
   validation mirroring v2 lib/validators: errors surface on blur and on
   submit (all touched + scroll to the first), the CTA dims while touched
   fields are invalid but stays clickable so a tap reveals what's missing.
   Real submission is Shopify's {% form %} POST. Isolated IIFE. */
(function () {
  'use strict';
  var root = document.querySelector('[data-auth]');
  if (!root) return;

  // ── Password eye reveals + mode links (delegated) ──
  root.addEventListener('click', function (e) {
    var eye = e.target.closest('[data-pw-eye]');
    if (eye) {
      var wrap = eye.closest('.lbd-pwwrap');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var reveal = input.type === 'password';
      input.type = reveal ? 'text' : 'password';
      var s = eye.querySelector('[data-pw-show]');
      var h = eye.querySelector('[data-pw-hide]');
      if (s) s.hidden = reveal;
      if (h) h.hidden = !reveal;
      eye.setAttribute('aria-label', reveal ? 'Hide password' : 'Show password');
      return;
    }
    var to = e.target.closest('[data-auth-to]');
    if (to) setMode(to.getAttribute('data-auth-to'));
  });

  // ── Mode switching (login page: signin / forgot / forgot-success) ──
  var sub = root.querySelector('[data-auth-sub]');
  function setMode(m) {
    var panes = root.querySelectorAll('[data-auth-pane]');
    if (!panes.length) return;
    root.setAttribute('data-auth-mode', m);
    panes.forEach(function (p) { p.hidden = p.getAttribute('data-auth-pane') !== m; });
    if (sub) {
      var t = sub.getAttribute(m === 'signin' ? 'data-sub-signin' : 'data-sub-forgot');
      if (t) sub.textContent = t;
    }
    if (window.history && history.replaceState) {
      if (m === 'forgot') history.replaceState(null, '', '#recover');
      else history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
  // Initial mode: recover-form server errors or #recover deep link → forgot.
  if (root.querySelector('[data-recover-errors]')) setMode('forgot');
  else if (window.location.hash === '#recover') setMode('forgot');

  // ── Client validation (v2 lib/validators voice) ──
  function vName(v) { v = (v || '').trim(); if (!v) return 'REQUIRED'; if (v.length < 2) return 'ENTER YOUR FULL NAME'; if (!/^[\p{L}\s'-]+$/u.test(v)) return 'LETTERS ONLY'; return null; }
  function vEmail(v) { v = (v || '').trim(); if (!v) return 'REQUIRED'; if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'ENTER A VALID EMAIL ADDRESS'; return null; }
  function vPass(v) { if (!v) return 'REQUIRED'; return null; }
  function vPassNew(v) { if (!v) return 'REQUIRED'; if (v.length < 8) return 'MINIMUM 8 CHARACTERS'; return null; }

  root.querySelectorAll('form').forEach(function (formEl) {
    var fields = Array.prototype.slice.call(formEl.querySelectorAll('[data-field]'));
    if (!fields.length) return;
    var btn = formEl.querySelector('[data-auth-submit]');
    var touched = {};

    function validator(name, formEl2) {
      if (name === 'email' || name === 'remail') return vEmail;
      if (name === 'password') return vPass;
      if (name === 'newpassword') return vPassNew;
      if (name === 'first' || name === 'last') return vName;
      if (name === 'country') return function (v) { return v ? null : 'SELECT A COUNTRY'; };
      if (name === 'addr1' || name === 'city' || name === 'postal') return function (v) { return (v || '').trim() ? null : 'REQUIRED'; };
      if (name === 'aphone') return function (v) { v = (v || '').replace(/[\s\-()+.]/g, ''); if (!v) return 'REQUIRED'; if (!/^\d+$/.test(v) || v.length < 7) return 'ENTER A VALID PHONE NUMBER'; return null; };
      if (name === 'confirm') {
        return function (v) {
          var np = formEl2.querySelector('[data-field-name="newpassword"] input');
          if (!v) return 'REQUIRED';
          if (np && v !== np.value) return 'PASSWORDS DO NOT MATCH';
          return null;
        };
      }
      return function () { return null; };
    }
    function fieldName(f) { return f.getAttribute('data-field-name'); }
    function inputOf(f) { return f.querySelector('input, select'); }
    function errorFor(f) { var el = inputOf(f); return validator(fieldName(f), formEl)(el ? el.value : ''); }
    function reflect(f) {
      var msg = errorFor(f);
      var e = f.querySelector('[data-err]');
      if (msg && touched[fieldName(f)]) {
        f.classList.add('is-error');
        if (e) { e.textContent = msg; e.removeAttribute('hidden'); }
      } else {
        f.classList.remove('is-error');
        if (e) e.setAttribute('hidden', '');
      }
    }
    function refreshButton() {
      if (!btn) return;
      var bad = false, any = false;
      fields.forEach(function (f) { if (errorFor(f)) bad = true; if (touched[fieldName(f)]) any = true; });
      btn.classList.toggle('is-incomplete', any && bad);
    }

    fields.forEach(function (f) {
      var el = inputOf(f);
      if (!el) return;
      el.addEventListener('change', function () {
        touched[fieldName(f)] = true;
        reflect(f);
        refreshButton();
      });
      el.addEventListener('blur', function () {
        touched[fieldName(f)] = true;
        // "Minimum 8 characters" helper yields to the field's own verdict.
        var helper = f.querySelector('[data-pw-helper]');
        if (helper) helper.hidden = true;
        reflect(f);
        refreshButton();
      });
      el.addEventListener('input', function () {
        if (touched[fieldName(f)]) reflect(f);
        refreshButton();
      });
    });

    formEl.addEventListener('submit', function (e) {
      var bad = false;
      fields.forEach(function (f) { touched[fieldName(f)] = true; reflect(f); if (errorFor(f)) bad = true; });
      refreshButton();
      if (bad) {
        e.preventDefault();
        var first = formEl.querySelector('.lbd-field.is-error');
        if (first) {
          first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var el = first.querySelector('input');
          if (el) window.setTimeout(function () { el.focus(); }, 350);
        }
      }
    });
  });
})();

/* Account dashboard — Make default: v2's 200ms fade on the block, then the
   hidden Shopify customer_address form (same address + default=true) posts
   and the page returns with the new order. Isolated IIFE. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dash]');
  if (!root) return;
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-make-default]');
    if (!btn) return;
    var block = btn.closest('[data-addr]');
    var form = block && block.querySelector('form');
    if (!form) return;
    block.classList.add('is-fading');
    window.setTimeout(function () { form.submit(); }, 200);
  });
})();

/* Address book — v2 address-form.jsx mechanics over /account/addresses.
   ?edit=<id> shows that address's pre-filled form and swaps the title to
   "Edit address." (everything is server-rendered; this only toggles).
   Country selects populate their province partner from Shopify's option
   tags (the province field reveals only when the country has zones), and
   Delete runs the v2 italic link with an inline are-you-sure swap before
   posting Shopify's _method=delete. Isolated IIFE. */
(function () {
  'use strict';
  var root = document.querySelector('[data-adr]');
  if (!root) return;

  // ── Mode: ?edit=<id> → that pane + title swap ──
  var params = new URLSearchParams(window.location.search);
  var editId = params.get('edit');
  var title = root.querySelector('[data-adr-title]');
  var panes = root.querySelectorAll('[data-adr-pane]');
  var target = editId && root.querySelector('[data-adr-pane="' + editId + '"]');
  panes.forEach(function (p) { p.hidden = true; });
  if (target) {
    target.hidden = false;
    if (title) title.textContent = 'Edit address.';
  } else {
    var add = root.querySelector('[data-adr-pane="new"]');
    if (add) add.hidden = false;
  }

  // ── Country → province wiring (Shopify option tags carry the zones) ──
  root.querySelectorAll('[data-adr-country]').forEach(function (sel) {
    var pane = sel.closest('[data-adr-pane]');
    var wrap = pane && pane.querySelector('[data-adr-provwrap]');
    var prov = wrap && wrap.querySelector('[data-adr-province]');
    var saved = sel.getAttribute('data-default');
    if (saved) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === saved || sel.options[i].text === saved) { sel.selectedIndex = i; break; }
      }
    }
    function syncProvinces() {
      if (!wrap || !prov) return;
      var opt = sel.options[sel.selectedIndex];
      var raw = opt && opt.getAttribute('data-provinces');
      var zones = [];
      try { zones = raw ? JSON.parse(raw) : []; } catch (e) {}
      if (!zones.length) { wrap.hidden = true; prov.innerHTML = ''; return; }
      var savedProv = prov.getAttribute('data-default');
      prov.innerHTML = zones.map(function (z) {
        var sel2 = (z[0] === savedProv || z[1] === savedProv) ? ' selected' : '';
        return '<option value="' + z[0] + '"' + sel2 + '>' + z[1] + '</option>';
      }).join('');
      wrap.hidden = false;
    }
    sel.addEventListener('change', syncProvinces);
    syncProvinces();
  });

  // ── Delete — inline confirm, then Shopify's _method=delete POST ──
  root.addEventListener('click', function (e) {
    var ask = e.target.closest('[data-adr-del-ask]');
    if (ask) {
      var row = ask.closest('[data-adr-del]');
      ask.hidden = true;
      var c = row.querySelector('.lbd-adr-delconfirm');
      if (c) c.hidden = false;
      return;
    }
    var no = e.target.closest('[data-adr-del-no]');
    if (no) {
      var row2 = no.closest('[data-adr-del]');
      row2.querySelector('.lbd-adr-delconfirm').hidden = true;
      row2.querySelector('[data-adr-del-ask]').hidden = false;
      return;
    }
    var yes = e.target.closest('[data-adr-del-yes]');
    if (yes) {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = yes.getAttribute('data-del-url');
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f);
      f.submit();
    }
  });
})();

/* Edit details — Send reset link posts Shopify's recover form in place and
   swaps to the italic confirmation (a full navigation would bounce off
   /account/login, which redirects logged-in customers). Falls back to the
   real POST if the fetch is blocked. Isolated IIFE. */
(function () {
  'use strict';
  var form = document.querySelector('[data-ed-reset-form]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { body.append(k, v); });
    window.fetch(form.action, { method: 'POST', body: body, headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (r.url && r.url.indexOf('challenge') !== -1) { form.submit(); return; }
        var pw = document.querySelector('[data-ed-pw]');
        var ok = document.querySelector('[data-ed-sent]');
        if (pw) pw.hidden = true;
        if (ok) ok.hidden = false;
      })
      .catch(function () { form.submit(); });
  });
})();

/* PDP colour row — scroll affordance (mobile). With fixed spacing, some
   viewport widths land the visible swatches EXACTLY flush with the screen
   edge and the row reads as complete — nothing hints it scrolls. When the
   row overflows, the gap is tuned around its 6px base (3–12px) so the next
   swatch always straddles the right edge, on any device width. Rows that
   fit entirely are left alone. Desktop (wrapping grid) is untouched. */
(function () {
  'use strict';
  var row = document.querySelector('[data-opt="Color"] .lbd-swatch-row');
  if (!row) return;
  var mqDesktop = window.matchMedia(window.LBD_DESKTOP_MQ);

  function tune() {
    if (mqDesktop.matches) { row.style.removeProperty('--pdp-swgap'); return; }
    var cells = row.querySelectorAll('.lbd-swatch-cell');
    if (cells.length < 2) return;
    var cellW = cells[0].offsetWidth;
    var padL = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    var W = row.clientWidth;
    // Aim: cell k's swatch centre sits on the right edge → k full cells shown.
    var k = Math.max(1, Math.round((W - padL - cellW / 2) / (cellW + 6)));
    var g = (W - padL - cellW / 2 - k * cellW) / k;
    var guard = 0;
    while (guard++ < 6 && (g < 3 || g > 12)) {
      k += g < 3 ? -1 : 1;
      if (k < 1) { k = 1; break; }
      g = (W - padL - cellW / 2 - k * cellW) / k;
    }
    // Row fits without scrolling at the base gap → no peek needed.
    if (cells.length <= k) { row.style.removeProperty('--pdp-swgap'); return; }
    row.style.setProperty('--pdp-swgap', Math.max(3, Math.min(12, g)).toFixed(2) + 'px');
  }

  window.addEventListener('resize', function () { requestAnimationFrame(tune); }, { passive: true });
  tune();
})();

/* PDP desktop — release geometry for the pinned gallery. The gallery is
   sized from the viewport (CSS width cap), so image + thumbs always fit and
   the sticky pin is pure CSS. This IIFE owns two CONSTANTS so accordions
   can never tug the pinned column:
   1. info paddingBottom = thumb block height, so the columns release into
      one scroll level with the square IMAGE's bottom edge;
   2. the gallery column's height = the info column's height AS IF every
      accordion were closed (open bodies subtracted) — that height is the
      sticky RELEASE point. Opening an accordion only pushes the content
      BELOW the grid; the release point, and the gallery riding on it,
      stay put even when the gallery has already released and is scrolling
      away. Desktop only. */
(function () {
  'use strict';
  var grid = document.querySelector('.lbd-pdp-grid');
  if (!grid) return;
  var col = grid.querySelector('.lbd-gallery-col');
  var gallery = grid.querySelector('.lbd-gallery-wrap');
  var info = grid.querySelector('.lbd-pdp-info');
  if (!col || !gallery || !info) return;
  var mq = window.matchMedia(window.LBD_DESKTOP_MQ);
  var thumbs = gallery.querySelector('[data-gallery-thumbs]');

  function apply() {
    if (!mq.matches) { info.style.paddingBottom = ''; col.style.height = ''; return; }
    info.style.paddingBottom = (thumbs ? thumbs.offsetHeight + 16 : 0) + 'px';
    var h = info.offsetHeight;
    info.querySelectorAll('.lbd-acc-item[open] .lbd-acc-body').forEach(function (b) {
      h -= b.offsetHeight;
    });
    col.style.height = Math.max(h, gallery.offsetHeight) + 'px';
  }

  // 'toggle' doesn't bubble, but a capture listener on the column sees it.
  info.addEventListener('toggle', function () { requestAnimationFrame(apply); }, true);
  window.addEventListener('resize', function () { requestAnimationFrame(apply); }, { passive: true });
  window.addEventListener('load', apply);
  apply();
})();
/* Plate paint — product photos are square on a solid backdrop, shown in 4:5
   plates with object-fit:contain, so the letterbox bands must match each
   photo's own backdrop. We sample the image's corner (always pure backdrop for
   a centred product) and paint the plate. To keep the VISIBLE images safe (a
   crossorigin attr would break them if a CDN ever omitted CORS headers), the
   sample is taken from a SEPARATE tiny (width=40) crossorigin copy — the corner
   colour is identical at any size, the extra fetch is ~1-3KB, and if CORS is
   unavailable the sample just fails and the plate keeps its CSS fallback colour.
   Results cache in localStorage keyed by the size-independent image path, so
   repeat views are instant and flash-free. Desktop-and-mobile, all card types;
   dynamically injected cards (cart/wishlist/cross-sell/carousels) are caught by
   a MutationObserver. */
(function () {
  'use strict';
  var CACHE_KEY = 'lbd:plate';
  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}') || {}; } catch (e) {}
  var dirty = false, saveArmed = false;
  var defer = window.requestIdleCallback
    ? function (cb) { window.requestIdleCallback(cb, { timeout: 800 }); }
    : function (cb) { window.setTimeout(cb, 500); };
  function save() {
    if (saveArmed) return; saveArmed = true;
    defer(function () {
      saveArmed = false; if (!dirty) return; dirty = false;
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    });
  }

  // Size-independent key + tiny sampling URL (same photo, any width → one colour).
  function keyFor(src) {
    try { var u = new URL(src, location.href); return u.origin + u.pathname; }
    catch (e) { return String(src).split('?')[0]; }
  }
  function tinyUrl(src) {
    if (/^data:/.test(src)) return src;
    try { var u = new URL(src, location.href); u.searchParams.set('width', '40'); return u.href; }
    catch (e) { return src; }
  }

  var canvas, ctx;
  function cornerColor(img) {
    if (!canvas) {
      canvas = document.createElement('canvas'); canvas.width = 24; canvas.height = 24;
      ctx = canvas.getContext('2d', { willReadFrequently: true });
    }
    ctx.clearRect(0, 0, 24, 24);
    ctx.drawImage(img, 0, 0, 24, 24);
    var d = ctx.getImageData(0, 0, 24, 24).data;      // one readback
    function px(x, y) { var i = (y * 24 + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    // Average the four corners — all pure backdrop for a centred product; the
    // average absorbs a stray corner and lands exactly on a solid fill.
    var pts = [px(1, 1), px(22, 1), px(1, 22), px(22, 22)], r = 0, g = 0, b = 0, n = 0;
    for (var i = 0; i < pts.length; i++) {
      if (pts[i][3] < 200) continue;                  // skip transparent
      r += pts[i][0]; g += pts[i][1]; b += pts[i][2]; n++;
    }
    if (!n) return null;
    return 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
  }

  function paintPlate(plate, img) {
    if (!plate || !img || img.__plateSeen) return;
    img.__plateSeen = true;
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return;
    var key = keyFor(src);
    if (cache[key]) { plate.style.backgroundColor = cache[key]; return; }   // instant, no fetch
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var col;
      try { col = cornerColor(probe); } catch (e) { return; }               // CORS taint → keep fallback
      if (!col) return;
      plate.style.backgroundColor = col;
      cache[key] = col; dirty = true; save();
    };
    probe.onerror = function () { /* CORS/network unavailable → keep fallback */ };
    probe.src = tinyUrl(src);
  }

  function scan(root) {
    var plates = (root || document).querySelectorAll('[data-plate-bg]');
    for (var i = 0; i < plates.length; i++) {
      var img = plates[i].querySelector('img');
      if (img) paintPlate(plates[i], img);
    }
    // Also handle a data-plate-bg that IS matched inside an added subtree root.
    if (root && root.matches && root.matches('[data-plate-bg]')) {
      var im = root.querySelector('img'); if (im) paintPlate(root, im);
    }
  }

  function boot() {
    scan(document);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('[data-plate-bg]')) scan(node);
            else if (node.querySelector && node.querySelector('[data-plate-bg]')) scan(node);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* PLP device switch — carry the applied filters along. The Device selector
   rows are plain links to another collection, which used to drop every
   applied facet (colour, leather, sort). Shopify filter params are
   collection-agnostic, so on click we graft the current URL's filter.* and
   sort_by params onto the target collection URL — pick 17 Pro + Black +
   Alligator, switch to Air, and the same filters stay applied. A value with
   no matches there simply yields an empty (clearable) result, which beats
   silently losing the selection. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-device-link]') : null;
    if (!a) return;
    var cur = new URLSearchParams(window.location.search);
    var carry = new URLSearchParams();
    cur.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 || k === 'sort_by') carry.append(k, v);
    });
    var has = false;
    carry.forEach(function () { has = true; });
    if (!has) return;   // nothing applied — plain navigation
    e.preventDefault();
    var u;
    try { u = new URL(a.href, window.location.origin); } catch (err) { return; }
    carry.forEach(function (v, k) { u.searchParams.append(k, v); });
    window.location.href = u.pathname + '?' + u.searchParams.toString();
  });
})();

/* PDP back-to-collection — return the visitor to WHERE THEY WERE, not just to
   the collection's top.
   1. Referrer is the same collection page → the click becomes history.back():
      the browser's bfcache restores the grid instantly — scroll position,
      Load-More-appended pages and applied filters included. (Safe: the PDP
      only ever replaceState()s, so back = the previous page.) The href is
      also upgraded to the full referrer as the no-bfcache fallback.
   2. Any navigation through the link sets a one-shot 'lbd:backnav' flag; the
      PLP-side restorer (below the Load more module) uses it to re-load the
      same number of pages and re-scroll when the page arrives cold. */
(function () {
  'use strict';
  var link = document.querySelector('[data-back-link]');
  if (!link) return;
  // Market subfolders (labodet.com/en-us/…) prefix EVERY path, so a bare
  // /^\/collections/ test only ever matches in the default market. Outside it
  // the referrer upgrade below silently no-opped and the visitor was dropped on
  // the canonical device collection instead of the grid they had been browsing
  // — the same bug the upgrade exists to prevent, just market-gated. Strip the
  // market root before asking what KIND of surface the referrer is. Shopify
  // publishes the root via content_for_header ('/' on the default market,
  // '/en-us/' on a subfolder one); '/' normalises to '' so the default market
  // takes the identity path.
  var mktRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  mktRoot = mktRoot.replace(/\/+$/, '');
  function unroot(p) {
    if (mktRoot && (p === mktRoot || p.indexOf(mktRoot + '/') === 0)) return p.slice(mktRoot.length) || '/';
    return p;
  }
  var refSamePage = false;
  try {
    var own = new URL(link.href, window.location.origin);
    if (document.referrer) {
      var ref = new URL(document.referrer);
      var refPath = unroot(ref.pathname);
      if (ref.origin === window.location.origin) {
        if (ref.pathname === own.pathname) {
          // Same grid the crumb names — keep its filters/sort. Compared with the
          // prefixes still ON: both sides come from the same market, so they
          // either both carry the root or neither does.
          refSamePage = true;
          if (ref.search) link.href = ref.pathname + ref.search;
        } else if (/^\/(collections|search)(\/|$)/.test(refPath) || /^\/pages\//.test(refPath)) {
          // The visitor came from a DIFFERENT grid than the canonical crumb:
          // a One-of-One or Limited piece met in the ordinary iPhone grid, or a
          // device sub-collection. Sending them to the edition's own styled page
          // (or to another collection) loses their place and their context, and
          // the scroll restorer can't match a URL they were never on. Honour
          // where they actually were. The bottom breadcrumb + JSON-LD keep the
          // canonical crumb, so SEO is untouched.
          refSamePage = true;
          link.href = ref.pathname + ref.search;
          link.setAttribute('aria-label', 'Back to collection');
        }
      }
    }
  } catch (e) { /* malformed referrer — keep the clean href */ }
  link.addEventListener('click', function (e) {
    try {
      var u = new URL(link.href, window.location.origin);
      sessionStorage.setItem('lbd:backnav', u.pathname + u.search);
    } catch (err) { /* storage unavailable — plain navigation still works */ }
    if (refSamePage && window.history.length > 1) {
      e.preventDefault();
      window.history.back();
    }
  });
})();

/* PLP SEO footer — clamp the long text to a few lines behind an inline serif
   "Read more". Clamping is applied by JS (not the stylesheet) so no-JS
   visitors and crawlers see the full text; the toggle only appears when the
   text actually overflows the clamp. */
(function () {
  'use strict';
  var block = document.querySelector('[data-seo-block]');
  if (!block) return;
  var body = block.querySelector('[data-seo-body]');
  var toggle = block.querySelector('[data-seo-toggle]');
  if (!body || !toggle) return;
  body.classList.add('is-clamped');
  // Only offer the toggle when the clamp actually hides something.
  if (body.scrollHeight > body.clientHeight + 4) {
    toggle.hidden = false;
  } else {
    body.classList.remove('is-clamped');
  }
  toggle.addEventListener('click', function () {
    var open = !body.classList.contains('is-clamped');
    if (open) {
      body.classList.add('is-clamped');
      toggle.textContent = 'Read more';
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      body.classList.remove('is-clamped');
      toggle.textContent = 'Read less';
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
})();

/* Load more — appends the next paginated page into the live grid, keeping
   everything already scrolled past. The button is a real link to the next
   page, so with JS off it still navigates. Appended cards get their plate
   colour painted by the [data-plate-bg] MutationObserver above. */
(function () {
  'use strict';
  var region = document.querySelector('[data-loadmore]');
  if (!region) return;
  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;
  var shownEl = region.querySelector('[data-loadmore-shown]');

  // ── Complete-rows clamp ─────────────────────────────────────────────
  // Featured cards span 2 columns, so a page of 24 products renders 24 + N
  // cells (N = featured on the page) — rarely a multiple of the column count
  // (4 desktop / 2 mobile). That left an orphaned card + holes right before
  // the button. We hide the trailing INCOMPLETE row (cards stay in the DOM)
  // so the grid always ends flush; the held cards reveal as Load more appends
  // the next page. On the last page (no next link) everything shows — it's the
  // true end of the catalogue, where a short final row is expected.
  function nextAvailable() {
    var b = region.querySelector('[data-loadmore-btn]');
    return !!(b && b.getAttribute('href'));
  }
  function cardSpan(el) {
    return el.classList && el.classList.contains('lbd-card-feat') ? 2 : 1;
  }
  function colCount() {
    var t = getComputedStyle(grid).gridTemplateColumns;
    if (!t || t === 'none') return 1;
    return t.split(' ').filter(Boolean).length;
  }
  function syncShown() {
    if (!shownEl) return;
    var n = 0, ch = grid.children;
    for (var i = 0; i < ch.length; i++) {
      if (!ch[i].classList.contains('is-rowhold')) n++;
    }
    shownEl.textContent = n;
  }
  function clampRows() {
    var cards = Array.prototype.slice.call(grid.children);
    for (var k = 0; k < cards.length; k++) cards[k].classList.remove('is-rowhold');
    // Last page (or single column): nothing to defer, show the real remainder.
    var cols = colCount();
    if (!nextAvailable() || cols < 2 || !cards.length) { syncShown(); return; }
    // Read the browser's ACTUAL placement rather than simulating it: group cards
    // by their rendered top edge (featured cards span 2, and the server can append
    // "leftover" featured out of visual order, so DOM order ≠ row order). Each
    // row's span is the sum of its cards' column spans; a row is full when that
    // reaches the column count.
    var rows = [];
    var cur = null, curTop = null;
    for (var i = 0; i < cards.length; i++) {
      var top = Math.round(cards[i].offsetTop);
      if (cur === null || Math.abs(top - curTop) > 1) {
        cur = { items: [], span: 0 };
        rows.push(cur);
        curTop = top;
      }
      cur.items.push(cards[i]);
      cur.span += cardSpan(cards[i]);
    }
    // Find the last row that fills every column; hide everything below it so the
    // grid ends flush. If not even the first row is full, leave all shown.
    var lastFull = -1;
    for (var r = 0; r < rows.length; r++) { if (rows[r].span >= cols) lastFull = r; }
    if (lastFull >= 0 && lastFull < rows.length - 1) {
      for (var r2 = lastFull + 1; r2 < rows.length; r2++) {
        for (var m = 0; m < rows[r2].items.length; m++) rows[r2].items[m].classList.add('is-rowhold');
      }
    }
    syncShown();
  }
  clampRows();
  // Re-run once layout has settled (fonts/first paint) — cheap and idempotent.
  requestAnimationFrame(function () { requestAnimationFrame(clampRows); });

  // Column count flips at the desktop breakpoint (LBD_DESKTOP_MQ) — re-clamp on resize. Also
  // re-run after full load in case the first layout wasn't settled yet.
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(clampRows, 150);
  });
  window.addEventListener('load', clampRows);

  // Carry the preview theme id across the fetch so the drafted theme keeps
  // rendering its own pages (Shopify strips it from paginate.next.url).
  function withPreview(url) {
    var m = window.location.search.match(/[?&](preview_theme_id=\d+)/);
    if (!m) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + m[1];
  }

  // Fetch the SECTION, not the whole page. Every appended page used to cost a
  // full server render (header, nav, filter drawer, SEO block, footer, JSON-LD)
  // of which only the grid was kept — and the scroll restorer multiplies that
  // by the number of pages being restored. The Section Rendering API returns
  // just this section's markup, which still carries [data-product-grid] and
  // [data-loadmore-btn], so the parsing below is unchanged.
  // No data-section-id (search template renders no section) → full page, as before.
  var sectionId = region.getAttribute('data-section-id');
  function withSection(url) {
    if (!sectionId) return url;
    if (url.indexOf('section_id=') >= 0) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
  }

  // Pages appended this visit — the scroll restorer (below) re-loads the same
  // count when the visitor comes back to a cold page.
  var pagesLoaded = 0;

  function loadNextPage(cb) {
    var btn = region.querySelector('[data-loadmore-btn]');
    var url = btn && btn.getAttribute('href');
    if (!btn || !url) { if (cb) cb(false); return; }
    var label = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Loading…';

    // Section first; if it ever comes back without a grid (section id changed,
    // API hiccup) fall back ONCE to the full page so the button can't dead-end.
    function get(u) {
      return fetch(u, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); });
    }
    var plainUrl = withPreview(url);
    var firstUrl = withSection(plainUrl);
    get(firstUrl)
      .then(function (html) {
        if (firstUrl === plainUrl) return html;
        var probe = new DOMParser().parseFromString(html, 'text/html');
        return probe.querySelector('[data-product-grid]') ? html : get(plainUrl);
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) {
          while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
        }
        pagesLoaded++;
        region.dataset.pagesLoaded = String(pagesLoaded);
        var next = doc.querySelector('[data-loadmore-btn]');
        if (next && next.getAttribute('href')) {
          btn.setAttribute('href', next.getAttribute('href'));
          btn.textContent = label;
          btn.classList.remove('is-loading');
        } else {
          btn.remove();
        }
        // Re-clamp AFTER the button state is updated: on the last page the
        // button is gone, so clampRows() reveals the held final-row cards.
        clampRows();
        if (cb) cb(true);
      })
      .catch(function () {
        btn.textContent = label;
        btn.classList.remove('is-loading');
        if (cb) cb(false);
      });
  }

  // Bulk restore for the scroll-memory module: fetch pages 2..count+1 in
  // PARALLEL (one round-trip instead of N sequential ones), append them in
  // order, fast-forward the button to the right next page and re-clamp.
  window.__lbdRestorePages = function (count, done) {
    if (!count || count < 1) { if (done) done(); return; }
    var urls = [];
    for (var n = 2; n <= count + 1; n++) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(n));
      if (sectionId) u.searchParams.set('section_id', sectionId);   // section only, not the whole page
      urls.push(u.pathname + u.search);   // preview_theme_id, filters, sort all ride along
    }
    Promise.all(urls.map(function (u2) {
      return fetch(u2, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Same one-shot guard as Load more: a section response without a grid
          // falls back to the full page rather than losing the restored rows.
          if (!sectionId) return html;
          var probe = new DOMParser().parseFromString(html, 'text/html');
          if (probe.querySelector('[data-product-grid]')) return html;
          var full = new URL(u2, window.location.origin);
          full.searchParams.delete('section_id');
          return fetch(full.pathname + full.search, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
          }).then(function (r2) { return r2.text(); });
        })
        .catch(function () { return null; });
    })).then(function (htmls) {
      // The restorer's skeleton placeholders occupy the tail of the grid —
      // clear them first so the real cards land in the right order.
      var skels = grid.querySelectorAll('[data-skel]');
      for (var s = 0; s < skels.length; s++) skels[s].remove();
      var lastDoc = null;
      for (var i = 0; i < htmls.length; i++) {
        if (!htmls[i]) break;
        var doc = new DOMParser().parseFromString(htmls[i], 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (!newGrid || !newGrid.firstElementChild) break;
        while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
        pagesLoaded++;
        lastDoc = doc;
      }
      region.dataset.pagesLoaded = String(pagesLoaded);
      var btn = region.querySelector('[data-loadmore-btn]');
      if (btn && lastDoc) {
        var next = lastDoc.querySelector('[data-loadmore-btn]');
        if (next && next.getAttribute('href')) btn.setAttribute('href', next.getAttribute('href'));
        else btn.remove();
      }
      clampRows();
      if (done) done();
    });
  };

  region.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-loadmore-btn]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    loadNextPage();
  });
})();

/* PLP scroll memory — coming back to the grid returns you to where you left,
   not to the top. The position and the number of Load-More-appended pages are
   saved on every pagehide (per URL incl. filters, sessionStorage). Restores
   only when the arrival is a real return: browser back/forward, or the PDP's
   Back-to-collection link (one-shot 'lbd:backnav' flag) — a fresh visit from
   the menu still starts at the top. bfcache returns skip all of this (the
   page comes back alive, scroll intact); this path is the cold-load fallback:
   re-append the same number of pages, then jump to the saved offset. */
(function () {
  'use strict';
  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;
  var KEY = 'lbd:plp:' + window.location.pathname + window.location.search;

  window.addEventListener('pagehide', function () {
    try {
      var region = document.querySelector('[data-loadmore]');
      var pages = region && region.dataset.pagesLoaded ? Number(region.dataset.pagesLoaded) : 0;
      sessionStorage.setItem(KEY, JSON.stringify({
        y: Math.round(window.scrollY),
        p: pages,
        h: document.documentElement.scrollHeight
      }));
    } catch (e) { /* storage unavailable */ }
  });

  // Consume the one-shot back-link flag FIRST, before any early return — if it
  // survives this load (e.g. the saved-state gate bails), a LATER fresh visit
  // to the same PLP would false-positive as a return and jump mid-page. (The
  // bfcache case, where no load happens at all, is cleared by the global
  // pageshow handler at the top of this file.)
  var flagMatch = false;
  try {
    flagMatch = sessionStorage.getItem('lbd:backnav') === window.location.pathname + window.location.search;
    sessionStorage.removeItem('lbd:backnav');
  } catch (e) {}

  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!saved || !(saved.y > 0 || saved.p > 0)) return;

  var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var backForward = !!(navEntry && navEntry.type === 'back_forward');
  if (!backForward && !flagMatch) return;

  // We own the restore from here — stop the browser's own (it would aim at a
  // height that doesn't exist until the pages are re-appended).
  if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

  function jump() {
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, saved.y || 0);
    html.style.scrollBehavior = prev;
  }

  // 1. Reserve the saved document height on <html> and jump to the old
  //    offset. The pre-paint inline script in theme.liquid normally did both
  //    already (before first paint); this is idempotent belt-and-suspenders —
  //    the visitor is at their position, the cards stream in around it.
  document.documentElement.classList.add('is-plp-restoring');
  if (saved.h > 0) document.documentElement.style.minHeight = saved.h + 'px';
  jump();

  // 2. Fill the reserved space with quiet skeleton cards (plate tone + light
  //    sweep — see .lbd-skel-* in base.css) so the position the visitor
  //    stands on is never a blank void while the real pages travel.
  if (saved.p > 0) {
    var skelCount = Math.min(saved.p * 24, 96);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < skelCount; i++) {
      var cell = document.createElement('div');
      cell.className = 'lbd-skel-card';
      cell.setAttribute('data-skel', '');
      cell.setAttribute('aria-hidden', 'true');
      cell.innerHTML = '<div class="lbd-skel-plate"></div><div class="lbd-skel-line"></div><div class="lbd-skel-line"></div>';
      frag.appendChild(cell);
    }
    grid.appendChild(frag);
  }

  // 3. Fetch every missing page in ONE parallel burst; the fetcher swaps the
  //    skeletons for the real cards, then we release the reserved height and
  //    re-align (only if the visitor hasn't scrolled away meanwhile).
  function stayedPut() { return Math.abs(window.scrollY - (saved.y || 0)) < 60; }
  function finish() {
    var leftovers = grid.querySelectorAll('[data-skel]');
    for (var j = 0; j < leftovers.length; j++) leftovers[j].remove();
    document.documentElement.classList.remove('is-plp-restoring');
    if (saved.h > 0) document.documentElement.style.minHeight = '';
    if (stayedPut()) requestAnimationFrame(jump);
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    if (saved.p > 0 && window.__lbdRestorePages) window.__lbdRestorePages(saved.p, finish);
    else finish();
  });
})();

/* PLP ColorFeaturedCard — colour carousel. The card's [data-feat-colors] holds a
   JSON array of { name, src, href } per colour; the arrows step through it,
   swapping the plate photo, the "{Colour} · N colours" label and the card's own
   href (so a normal click opens the shown colour's variant). Delegated on the
   document so featured cards appended by Load More work without re-wiring. */
(function () {
  'use strict';
  function colorsOf(card) {
    if (card.__featColors !== undefined) return card.__featColors;
    var el = card.querySelector('[data-feat-colors]');
    var parsed = null;
    if (el) { try { parsed = JSON.parse(el.textContent); } catch (e) { parsed = null; } }
    card.__featColors = parsed;
    return parsed;
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest ? e.target.closest('[data-feat-prev],[data-feat-next]') : null;
    if (!arrow) return;
    var card = arrow.closest('[data-feat-card]');
    if (!card) return;
    var colors = colorsOf(card);
    if (!colors || colors.length < 2) return;
    e.preventDefault();
    e.stopPropagation();
    var dir = arrow.hasAttribute('data-feat-next') ? 1 : -1;
    // First interaction starts from the server-rendered colour (data-feat-start —
    // e.g. the filtered colour when a colour filter is applied), not from 0.
    var cur = card.__featIdx;
    if (cur === undefined) cur = parseInt(card.getAttribute('data-feat-start'), 10) || 0;
    var idx = ((cur + dir) % colors.length + colors.length) % colors.length;
    card.__featIdx = idx;
    var c = colors[idx];
    var img = card.querySelector('[data-feat-img]');
    var nameEl = card.querySelector('[data-feat-name]');
    if (img && c.src) img.src = c.src;
    if (nameEl) nameEl.textContent = c.name;
    if (c.href) card.setAttribute('href', c.href);
    // Price follows the shown colour — an outlet product discounts ONE variant,
    // the other colourways sell at full price (compare toggles the struck line).
    var priceEl = card.querySelector('[data-feat-price]');
    var cmpEl = card.querySelector('[data-feat-compare]');
    // snippets/price emits &nbsp; entities — decode for textContent.
    function money(s) { return (s || '').replace(/&nbsp;/g, ' '); }
    if (priceEl && c.price) priceEl.textContent = money(c.price);
    if (cmpEl) {
      if (c.compare) { cmpEl.textContent = money(c.compare); cmpEl.hidden = false; }
      else { cmpEl.textContent = ''; cmpEl.hidden = true; }
    }
  });
})();
